import React, { Component } from 'react';
import Styles from './style.css';
import HeaderSignupTwo from "../../components/header-signup-two/component";
import { BeatLoader } from 'react-spinners';
import InputMask from 'react-input-mask';
import cx from "classnames";
import { langRegister } from "../../services/langRegister";
import { dataRegister } from "../../services/dataRegister";
import { userRegister } from "../../services/userRegister";
import { cartRegister } from "../../services/cartRegister";
import countryCodes from "country-telephone-data";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import { campaignRegister } from "../../services/campaignRegister";
import Autocomplete from 'react-google-autocomplete';
import { salesChannelRegister } from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import queryString from "query-string";
import { injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import BoosterHeaderSecond from "../../components/booster-header-second/component";
import { scraperRegister } from "../../services/scraperRegister";
import ModalCoupon from "../../components/modal-coupon/component";
import { carouselRegister } from "../../services/carouselRegister";
import { videoRegister } from "../../services/videoRegister";
import { flowRegister } from "../../services/flowRegister";
import { canvasRegister } from "../../services/canvasRegister";
import { themeRegister } from "../../services/themeRegister";
import { imagesRegister } from "../../services/imagesRegister";
import { collectedRegister } from "../../services/collectedRegister";
import { yieldlockRegister } from "../../services/yieldlockRegister";
import { tokenRegister } from "../../services/tokenRegister";
import { agentRegister } from "../../services/agentRegister";
import { blurRegister } from "../../services/blurRegister";
import Dropdown from '../../components/dropdown/component';

const hash = require('object-hash');

class BoosterPayment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            landingpage: false,
            show_phone: false,
            register: false,
            autocomplete_predictions: [],
            payment_methods: [],
            images: [],
            interface_lang: {},
            form_validation: {},
            lockin_plan: {},
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            company_name: "",
            website: "",
            own_website: "",
            phone: "",
            card_number: "",
            card_month: "",
            card_year: "",
            card_ccv: "",
            send_to: "",
            autocomplete_search: "",
            logged_in: false,
            admin: false,
            lockin: false,
            pay_now: true,
            currency: null,
            card_error: {
                number: false,
                expiry: false,
                cvc: false,
                show: false,
                message: ""
            },
            secure_payment: false,
            secure_payment_ur: "",
            landing_address: "",
            landing_address_id: "",
            landing_email: "",
            lat: null,
            lng: null,
            countries: [],
            country: null,
            dropdown: false,
            search: "",
            address: "",
            campaign: null,
            service_fee_fixed: null,
            service_fee_percentage: null,
            redirect_email: "",
            redirect: false,
            user_email: "",
            reseller: false,
            whatsapp: true,
            system_error: false,
            user_error: false,
            private_user: false,
            broker_name: "",
            broker_brn: "",
            broker_company: "",
            broker_image: "",
            broker_trakheesi: "",
            broker_ref: "",
            broker_qrcode: "",
            plugin_conveyancing: false,
            plugin_listings: false,
            plugin_leadform_earlyaccess: false,
            plugin_leadform_moreinfo: true,
            plugin_leadform_viewing: false,
            plugin_leadform_callback: false,
            plugin_image_blocker: true,
            plugin_prequalify: false,
            plugin_extraservices: false,
            isCouponLoading: false,
            coupon: "",
            coupon_success: false,
            plugin_agency_listings: false,
            branding_pref: [],
            fallback_pref: [],
            branding: false,
            ga_id_branding: "",
            ga4_id_branding: "",
            fb_id_branding: "",
            tiktok_id_branding: "",
            snapchat_id_branding: "",
            strategy: {},
            preview_slideshow: false,
        };
        this.google = window.google;
        this.functions.setCouponModal = this.functions.setCouponModal.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        this.update.leadFormPlugin();
        this.update.user();
        this.update.data();
        this.update.brokerInformation();
        this.update.scraperInformation();
        this.update.countries();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/payment');
            ReactGA4.send({ hitType: "pageview", page: "/booster/payment" });
        }
        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }

        if (salesChannelRegister.get("name") === "yieldlock") {
            this.setState({
                landingpage: true,
                plugin_conveyancing: true
            });
        }

        if (salesChannelRegister.get("name") === "propertybooster") {
            this.setState({
                landingpage: true,
                portal_url: false
            });
        }

        if (salesChannelRegister.get("name") === "boostabostad") {
            this.setState({
                landingpage: true,
                portal_url: false,
                whatsapp: false
            });
        }

        //SET STRATEGY VALUES FOR FEED
        this.state.strategy = {
            placeholder: this.parsers.text("item_112"),
            options: [
                { "id": 0, "type": 0, "result_cost": 40, "selected": true, "title": this.parsers.text("item_122") },
                //{ "id": 1, "type": 1, "result_cost": 8, "selected": true, "title": this.parsers.text("item_116") },
                { "id": 0, "type": 2, "result_cost": 50, "selected": true, "title": this.parsers.text("item_117") },
                { "id": 1, "type": 3, "result_cost": 150, "selected": true, "title": this.parsers.text("item_118") },
                { "id": 2, "type": 4, "result_cost": 350, "selected": true, "title": this.parsers.text("item_119") },
                //{ "id": 1, "type": 5, "result_cost": 180, "selected": true, "title": this.parsers.text("item_121") },
                //{ "id": 1, "type": 6, "result_cost": 220, "selected": true, "title": this.parsers.text("item_120") },
                //{ "id": 1, "type": 7, "result_cost": 360, "selected": true, "title": this.parsers.text("item_123") },

            ],
            value: JSON.stringify({ "id": 0, "type": 0, "result_cost": 40, "selected": true, "title": this.parsers.text("item_122") })
        };

        this.setState({
            strategy: this.state.strategy
        });

        /*
        //SET PIXELS
        this.state.strategy_pixels = {
            placeholder: this.parsers.text("item_113"),
            options: [
                { "id": 0, "selected": true, "title": this.parsers.text("item_115") }
            ],
            value: JSON.stringify({ "id": 0, "selected": true, "title": this.parsers.text("item_115") })
        };
        try {
            let user = userRegister.getUser();
            if (user.socialData && user.socialData.fb_id_branding) {
                this.state.strategy_pixels.options.push({ "id": 1, "selected": true, "title": user.billing_company });
            } else {
                this.state.strategy_pixels.disabled = true;
            }
        } catch (error) { }
                this.setState({
            strategy_pixels: this.state.strategy_pixels
        })
        */

        //SHOW STRATEY SECTION
        this.state.show_strategy = false;
        try {
            let cart = cartRegister.get();
            if (cart.options === 'instant') {
                this.state.show_strategy = true;
            }
        } catch (error) { }

        this.setState({
            show_strategy: this.state.show_strategy
        })

    }

    componentDidMount() {
        this.update.stripe();
        try {
            this.autocomplete = new this.google.maps.places.AutocompleteService();
        } catch (e) {
        }
        try {
            this.geocoder = new this.google.maps.Geocoder;
        } catch (e) {
        }

        let token = tokenRegister.getToken();
        if (!token) {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }

        if (!this.state.inhouse) {
            this.setState({
                show_one: true
            });
        }

        let user_data = userRegister.get();
        if (user_data && user_data.socialData && user_data.socialData.branding) {
            this.setState({
                branding: true,
                plugin_agency_listings: true
            });
        }
        if (user_data && user_data.socialData && user_data.socialData.preview_slideshow) {
            this.setState({
                preview_slideshow: true,
            });
        }


        //GET FEED DATA
        try {
            let flow_values_google = collectedRegister.getValue('google');
            this.state.feed_address = flow_values_google.autocomplete_address;
            this.setState({
                feed_address: this.state.feed_address
            });
        } catch (error) { }
        try {
            let flow_values_regions = collectedRegister.getValue('region_grid');
            let country = null;
            if (flow_values_regions[1].value) {
                country = JSON.parse(flow_values_regions[1].value).internationalname;
            }
            let region = null;
            if (flow_values_regions[2].value) {
                region = JSON.parse(flow_values_regions[2].value).internationalname;
            }
            let city = null;
            if (flow_values_regions[3].value) {
                city = JSON.parse(flow_values_regions[3].value).internationalname;
            }
            let neighborhood = null;
            if (flow_values_regions[4].value) {
                neighborhood = JSON.parse(flow_values_regions[4].value).internationalname;
            }
            this.setState({
                feed_country: country ? country : "",
                feed_region: region ? region : "",
                feed_city: city ? city : "",
                feed_neighborhood: neighborhood ? neighborhood : "",
            });
        } catch (error) { }


    }

    update = {
        leadFormPlugin: () => {

            try {

                let lang = langRegister.lang();
                let cart = cartRegister.get();
                let call_to_action = "";

                try {
                    call_to_action = (Object.keys(cart.quotes).filter((key) => {
                        return cart.quotes[key].selected
                    }).sort(function (a, b) {
                        if (cart.quotes[a].index < cart.quotes[b].index) {
                            return -1;
                        }
                        if (cart.quotes[a].index > cart.quotes[b].index) {
                            return 1;
                        }
                        return 0;
                    }).map((key) => {
                        return cart.quotes[key].slogan.toLowerCase()
                    }))
                } catch (e) {
                    call_to_action = null;
                }

                if (lang.toLowerCase() === "en") {
                    if (call_to_action[3].indexOf('view') !== -1 || call_to_action[3].indexOf('see it') !== -1) {
                        this.setState({
                            plugin_leadform_earlyaccess: false,
                            plugin_leadform_moreinfo: false,
                            plugin_leadform_viewing: true,
                            plugin_leadform_callback: false,
                        });
                    } else if (call_to_action[3].indexOf('call') !== -1 || call_to_action[3].indexOf('touch') !== -1 || call_to_action[3].indexOf('contact') !== -1) {
                        this.setState({
                            plugin_leadform_earlyaccess: false,
                            plugin_leadform_moreinfo: false,
                            plugin_leadform_viewing: false,
                            plugin_leadform_callback: true,
                        });
                    } else if (call_to_action[3].indexOf('early') !== -1 || call_to_action[3].indexOf('waiting list') !== -1 || call_to_action[3].indexOf('secure') !== -1 || call_to_action[3].indexOf('pre-book') !== -1) {
                        this.setState({
                            plugin_leadform_earlyaccess: true,
                            plugin_leadform_moreinfo: false,
                            plugin_leadform_viewing: false,
                            plugin_leadform_callback: false,
                        });
                    }
                } else if (lang.toLowerCase() === "sv") {
                    if (call_to_action[3].indexOf('visning') !== -1 || call_to_action[3].indexOf('se den') !== -1) {
                        this.setState({
                            plugin_leadform_earlyaccess: false,
                            plugin_leadform_moreinfo: false,
                            plugin_leadform_viewing: true,
                            plugin_leadform_callback: false,
                        });
                    } else if (call_to_action[3].indexOf('ring') !== -1 || call_to_action[3].indexOf('återkoppling') !== -1 || call_to_action[3].indexOf('hör av dig') !== -1 || call_to_action[3].indexOf('kontakta') !== -1) {
                        this.setState({
                            plugin_leadform_earlyaccess: false,
                            plugin_leadform_moreinfo: false,
                            plugin_leadform_viewing: false,
                            plugin_leadform_callback: true,
                        });
                    } else if (call_to_action[3].indexOf('säkra') !== -1 || call_to_action[3].indexOf('gå före') !== -1 || call_to_action[3].indexOf('förboka') !== -1) {
                        this.setState({
                            plugin_leadform_earlyaccess: true,
                            plugin_leadform_moreinfo: false,
                            plugin_leadform_viewing: false,
                            plugin_leadform_callback: false,
                        });
                    }
                }

            } catch (e) {
            }
        },
        data: () => {
            let stored_data = cartRegister.get();
            if (stored_data.admin_image) {
                if (!stored_data.admin_image.web_url) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                }
            }
            if (stored_data.budget && stored_data.regions && stored_data.industry && stored_data.channels && (stored_data.image || stored_data.admin_image) && (stored_data.quotes || stored_data.admin_quotes) && stored_data.plan) {
                if (stored_data.regions.length < 1) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images")
                } else {
                    this.setState({
                        industry: stored_data.industry,
                        market: salesChannelRegister.get('market'),
                        currency: salesChannelRegister.get('currency'),
                        vat: salesChannelRegister.get('vat'),
                        budget: stored_data.budget,
                        channels: stored_data.channels,
                        image: stored_data.image ? stored_data.image : stored_data.admin_image,
                        lockin: stored_data.lockin,
                        lockin_plan: stored_data.lockin_plan,
                        duration: stored_data.duration,
                        related: stored_data.related_industries ? stored_data.related_industries : [],
                        plan: stored_data.plan,
                        targets: stored_data.targets ? stored_data.targets : [],
                        age_range: stored_data.age_range ? stored_data.age_range : [],
                        service_fee_percentage: stored_data.servicefee_percentage,
                        service_fee_fixed: stored_data.servicefee_fixed,
                    });
                }
            } else {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images")
            }
        },
        scraperInformation: () => {

            //SET LISTING PLATFORM
            try {
                if (salesChannelRegister.get("name") !== "yieldlock") {
                    let platform = flowRegister.getValue("platform");
                    if (platform) {
                        if (platform === "CRM") {
                            this.setState({
                                listing_platform: platform,
                                portal_url: false,
                                website_url: false,
                                portal_exist: false
                            });
                        } else {
                            this.setState({
                                listing_platform: platform,
                                portal_url: platform === "Portal" || platform === "Website",
                                website_url: platform === "Website",
                                portal_exist: true
                            });
                        }
                    } else {
                        this.setState({
                            own_url: true
                        });
                    }
                }
            } catch (e) { }

            //SET WEBSITE
            try {
                let website = flowRegister.getValue("website");
                if (website) {
                    this.setState({
                        website: website
                    });
                }
            } catch (e) {
            }

            //SET ADDRESS
            try {
                let google = flowRegister.getValue("google");
                if (google) {
                    this.setState({
                        lat: google.autocomplete_lat,
                        lng: google.autocomplete_lng,
                        landing_address: google.autocomplete_full_address
                    });
                }
            } catch (e) {
            }

            //MAKE MAIN IMAGE TO FILE
            try {

                //GET FACEBOOK IMAGE TEMP SOLUTION
                let hash_code = null;
                let url = null;
                if (canvasRegister.facebook.url) {
                    if (canvasRegister.facebook.hash) {
                        hash_code = canvasRegister.facebook.hash;
                    } else {
                        if (JSON.parse(sessionStorage.getItem("canvas-facebook")).hash) {
                            hash_code = JSON.parse(sessionStorage.getItem("canvas-facebook")).hash;
                        }
                    }
                }
                if (hash_code === hash(canvasRegister.url("facebook"))) {
                    this.functions.getFileFromSrc(canvasRegister.facebook.url).then((results) => {
                        this.setState({ admin_image_file: this.functions.dataURItoBlob(results.data_url) });
                    }, (error) => {
                    });
                } else {
                    let cart = cartRegister.get();
                    if (cart.admin_image.web_url) {
                        this.functions.getFileFromSrc(cart.admin_image.web_url).then((results) => {
                            this.setState({ admin_image_file: this.functions.dataURItoBlob(results.data_url) });
                        }, (error) => {
                        });
                    }
                }
            } catch (e) {
            }

            //ADD COMPANY NAME -> (ADS TITLE)
            try {
                let company_name = flowRegister.getValue("company_name");
                if (company_name) {
                    this.setState({
                        company_name: company_name
                    });
                }
            } catch (e) {
            }


            /*
            try {
                let scraper_data = JSON.parse(scraperRegister.get());
                let cart = cartRegister.get();
                if (scraper_data.additional_information.facts) {
                    this.setState({
                        listing_platform: scraper_data.additional_information.facts.listing_platform ? scraper_data.additional_information.facts.listing_platform : null,
                        portal_url: true,
                        website: scraper_data.additional_information.url ? scraper_data.additional_information.url : "",
                    }, () => {
                        try {
                            if(scraper_data.additional_information.facts.address_full){
                                this.setState({
                                    lat: scraper_data.additional_information.facts.address_lat,
                                    lng: scraper_data.additional_information.facts.address_lng,
                                    landing_address: scraper_data.additional_information.facts.address_full
                                });
                            }
                        } catch (e) {}

                        try {
                            let cart = cartRegister.get();
                            if (cart.admin_image.web_url) {
                                this.functions.getFileFromSrc(cart.admin_image.web_url).then((results) => {
                                    this.setState({admin_image_file: this.functions.dataURItoBlob(results.data_url)});
                                }, (error) => {
                                    console.log(error);
                                });
                            }
                        } catch (e) {}

                        try {
                            if (scraper_data.images.length > 0) {
                                let promises = [];
                                let first_image = null;
                                for (let i = 0; i < scraper_data.images.length; i++) {
                                    try {
                                        if (this.state.image.original === scraper_data.images[i].original) {
                                            first_image = scraper_data.images[i];
                                        } else {
                                            promises.push(this.functions.getFileFromSrc(scraper_data.images[i].original));
                                        }
                                    } catch (e) {
                                        promises.push(this.functions.getFileFromSrc(scraper_data.images[i].original));
                                    }
                                }
                                if (first_image) {
                                    promises.unshift(this.functions.getFileFromSrc(first_image.original))
                                }
                                Promise.all(promises).then((results) => {
                                    let data = [];
                                    for (let i = 0; i < results.length; i++) {
                                        data.push(this.functions.dataURItoBlob(results[i].data_url))
                                    }
                                    this.setState({images: data});
                                });
                            } else {
                                let data = [];
                                let first_image = null;
                                for (let i = 0; i < cart.uploaded_images.length; i++) {
                                    try {
                                        if (this.state.image.date === cart.uploaded_images[i].date) {
                                            first_image = cart.uploaded_images[i];
                                        } else {
                                            data.push(this.functions.dataURItoBlob(cart.uploaded_images[i].data_url))
                                        }
                                    } catch (e) {
                                        data.push(this.functions.dataURItoBlob(cart.uploaded_images[i].data_url))
                                    }
                                }
                                if (first_image) {
                                    data.unshift(this.functions.dataURItoBlob(first_image.data_url))
                                }
                                this.setState({images: data});
                            }
                        } catch (e) {}

                        try {
                            if (scraper_data.region_grid) {
                                let lowest = 0;
                                for (let key in scraper_data.region_grid) {
                                    if (scraper_data.region_grid[key].value !== "-1" && scraper_data.region_grid[key].value && scraper_data.region_grid[key].level < 4) {
                                        if (+key > +lowest) {
                                            lowest = key;
                                        }
                                    }
                                }
                                this.setState({extra_region: JSON.parse(scraper_data.region_grid[lowest].value)}, () => {
                                    console.log(this.state.extra_region);
                                })
                            }
                        } catch (e) {}


                        try {
                            //let company_name = scraper_data.additional_information.facts.price;
                            //let currency = scraper_data.additional_information.facts.currency;

                            //SET PRICE AND CURRENCY
                            let company_name = 0;
                            let currency = null;


                            try {
                                if(JSON.parse(scraper_data.region_grid[1].value).id !== 4940){
                                    company_name = Math.round(scraper_data.additional_information.facts.price * 0.272245);
                                }else{
                                    company_name = scraper_data.additional_information.facts.price;
                                    currency = scraper_data.additional_information.facts.currency;
                                }
                            }catch (e) {}


                            company_name = scraper_data.additional_information.facts.price;
                            currency = scraper_data.additional_information.facts.currency;

                            if (+company_name > 0) {
                                if (currency) {
                                    company_name = currency + " " + this.parsers.number(company_name);
                                }
                                try {
                                    if (scraper_data.additional_information.facts.listing_type.indentifier === "rent") {
                                        company_name = company_name + " " + scraper_data.additional_information.facts.duration.title;
                                    }
                                } catch (e) {
                                }
                            } else {
                                company_name = 'Price on request';
                            }

                            if (company_name.toString().toLowerCase() !== "on request") {
                                var parts = company_name.toString().split(".");
                                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                                company_name = parts.join(".");

                                if (currency) {
                                    company_name = currency + " " + company_name;
                                }

                                try {
                                    if (scraper_data.additional_information.facts.listing_type.indentifier === "rent") {
                                        company_name = company_name + " " + scraper_data.additional_information.facts.duration.title;
                                    }
                                } catch (e) {
                                }

                            }

                            this.setState({company_name: company_name}, () => {
                                console.log(this.state.company_name);
                            });

                        } catch (e) {
                            console.log(e);
                        }

                    });
                }
            } catch (e) {
            }
            */
        },
        brokerInformation: () => {

            let user = userRegister.get();
            let agent = agentRegister.get();

            if (user) {

                let name = null;
                let phone = null;
                let permit = null;
                let email = null;
                let profile_image = null;

                let ga_id_branding = '';
                let ga4_id_branding = '';
                let fb_id_branding = '';
                let tiktok_id_branding = '';
                let snapchat_id_branding = '';

                if (agent && agent.profile_image) {
                    profile_image = agent.profile_image;
                }
                if (agent && agent.name) {
                    name = agent.name;
                }
                if (user.fallback_pref && user.fallback_pref.email) {
                    email = user.email;
                } else {
                    if (agent && agent.email) {
                        email = agent.email;
                    }
                }
                if (user.fallback_pref && user.fallback_pref.phone) {
                    phone = user.phone;
                } else {
                    if (agent && agent.phone) {
                        phone = agent.phone;
                    }
                }
                if (agent && agent.permit) {
                    permit = agent.permit;
                }

                if (user.socialData && user.socialData.ga_id_branding) {
                    ga_id_branding = user.socialData.ga_id_branding;
                }

                if (user.socialData && user.socialData.ga4_id_branding) {
                    ga4_id_branding = user.socialData.ga4_id_branding;
                }

                if (user.socialData && user.socialData.fb_id_branding) {
                    fb_id_branding = user.socialData.fb_id_branding;
                }

                if (user.socialData && user.socialData.tiktok_id_branding) {
                    tiktok_id_branding = user.socialData.tiktok_id_branding;
                }

                if (user.socialData && user.socialData.snapchat_id_branding) {
                    snapchat_id_branding = user.socialData.snapchat_id_branding;
                }

                this.setState({
                    broker_name: !name ? user.name : name,
                    landing_email: !email ? user.email : email,
                    phone: !phone ? user.phone : phone,
                    broker_brn: !permit ? user.vat_no : permit,
                    broker_company: user.billing_company,
                    broker_image: !profile_image ? user.profile_image : profile_image,
                    broker_logo: user.logo_image,
                    broker_trakheesi: !permit ? user.vat_no : permit,
                    branding_pref: user.branding_pref,
                    fallback_pref: user.fallback_pref,
                    ga_id_branding: ga_id_branding,
                    ga4_id_branding: ga4_id_branding,
                    fb_id_branding: fb_id_branding,
                    tiktok_id_branding: tiktok_id_branding,
                    snapchat_id_branding: snapchat_id_branding,
                }, () => {
                    //REMOVE COUNTRY CODE FROM PHONE
                    let countries = JSON.parse(JSON.stringify(countryCodes.allCountries));
                    for (let i = 0; i < countries.length; i++) {
                        countries[i].dialCode = "+" + countries[i].dialCode;
                        if (countries[i].iso2 === salesChannelRegister.get('market')) {
                            try {
                                let code = countries[i].dialCode;
                                this.state.phone = this.state.phone.replace(code, "");
                            } catch (e) {
                                console.log(e)
                            }
                        }
                    }
                    this.setState({
                        phone: this.state.phone
                    })
                });
            }

            try {
                if (collectedRegister.getValue("contact").ref) {
                    this.setState({
                        broker_ref: collectedRegister.getValue("contact").ref ? collectedRegister.getValue("contact").ref : ""
                    }, () => { });
                }
                if (collectedRegister.getValue("contact").permit) {
                    this.setState({
                        broker_trakheesi: collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                    }, () => { });
                }
                if (collectedRegister.getValue("contact").qrcode) {
                    this.setState({
                        broker_qrcode: collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                    }, () => { });
                }
            } catch (e) {
                console.log(e);
            }


            /*
            //SET BROKER INFO
            try {
                let scraper_data = JSON.parse(scraperRegister.get());
                let user = userRegister.get();
                if (scraper_data.additional_information.broker) {
                    this.setState({
                        broker_name: scraper_data.additional_information.broker.name ? scraper_data.additional_information.broker.name : "",
                        landing_email: scraper_data.additional_information.broker.email ? scraper_data.additional_information.broker.email : user.email,
                        phone: scraper_data.additional_information.broker.phone ? scraper_data.additional_information.broker.phone : "",
                        broker_brn: scraper_data.additional_information.broker.brn ? ("#" + scraper_data.additional_information.broker.brn) : "",
                        broker_company: scraper_data.additional_information.broker.company ? scraper_data.additional_information.broker.company : "",
                        broker_image: scraper_data.additional_information.broker.image ? scraper_data.additional_information.broker.image : "",
                        broker_trakheesi: scraper_data.additional_information.broker.trakheesi ? scraper_data.additional_information.broker.trakheesi : (scraper_data.additional_information.broker.license?scraper_data.additional_information.broker.license:""),
                    }, () => {});
                } else {
                    if (user) {
                        this.setState({
                            broker_name: user.name,
                            phone: '',
                            landing_email: user.email,
                            broker_brn: '',
                            broker_company: '',
                            broker_image: user.profile_image
                        }, () => {});
                    }
                }
            } catch (e) {
                console.log(e);
            }
            */

        },
        stripe: () => {
            try {
                window.stripe_api = window.Stripe(dataRegister.stripe_key);
                var elements = window.stripe_api.elements();
                var style = {
                    base: {
                        color: '#000000',
                        fontFamily: 'sans-serif',
                        lineHeight: '2.1',
                        fontSmoothing: 'antialiased',
                        fontSize: '15px',
                        '::placeholder': {
                            color: '#808080'
                        }
                    },
                    invalid: {
                        color: '#000000'
                    }
                };
                window.cardNumber = elements.create('cardNumber', {
                    style: style
                });
                window.cardNumber.mount('#card-number');
                window.cardExpiry = elements.create('cardExpiry', {
                    style: style
                });
                window.cardExpiry.mount('#card-expiry');
                window.cardCvc = elements.create('cardCvc', {
                    style: style
                });
                window.cardCvc.mount('#card-cvc');
            } catch (e) {
                this.setState({ system_error: true });
            }
        },
        user: () => {
            let user = userRegister.get();
            if (user) {
                this.setState({
                    logged_in: true,
                    user_email: user.email,
                    reseller: user.reseller,
                    inhouse: user.inhouse,
                    user_name: (user.name && user.name !== "") ? user.name : null,
                    user_image: (user.profile_image && user.profile_image !== "") ? user.profile_image : null
                });
            }
        },
        countries: () => {
            let countries = JSON.parse(JSON.stringify(countryCodes.allCountries));
            for (let i = 0; i < countries.length; i++) {
                countries[i].dialCode = "+" + countries[i].dialCode;
                if (countries[i].iso2 === salesChannelRegister.get('market')) {
                    this._selectCountry(countries[i]);
                }
            }
            this.setState({ countries: countries });
        },
        campaign: (token) => {

            let cart = cartRegister.get();
            let scraper_data = JSON.parse(scraperRegister.get());
            let campaign = {};

            //SET AUTO RENEW TO FALSE
            campaign.auto_renew = false;

            //SET SMART SPEND
            campaign.smart_spend = cart.smart_spend;
            //console.log(campaign.smart_spend + " SMART SPEND");

            //SET BROKER IMAGE
            try {
                campaign.broker_image = this.state.broker_image;
            } catch (e) {
            }

            //GREETINGS
            if ((this.state.reseller || this.state.inhouse) && !this.state.pay_now && this.state.greetings_invoice && this.state.redirect) {
                campaign.greetings_invoice = {
                    profile_image: this.state.greetings_invoice_profileimage,
                    name: true
                };
                campaign.greetings_invoice = JSON.stringify(campaign.greetings_invoice);
            }

            //IF COUPON CODE
            if (this.state.coupon_success) {
                campaign.coupon_code = this.state.coupon;
            }

            //SET CAROUSEL
            try {
                let hash_code = null;
                if (Array.isArray(cart.admin_slideshow_images) && cart.admin_slideshow_images.filter((item) => {
                    return item.selected
                }).length > 0) {
                    let carousel_ads = [];
                    let location = flowRegister.getValue("display_region");
                    let industry = cartRegister.get().industry.name;
                    cart.admin_slideshow_images.sort((a, b) => (a.number > b.number) ? 1 : -1).map((item) => {
                        let slide = {
                            image: item.images.small,
                            title: industry,
                            description: location
                        };
                        carousel_ads.push(slide);
                    });
                    campaign.carousel_ads = JSON.stringify(carousel_ads);
                } else {
                    if (carouselRegister.video.hash) {
                        hash_code = carouselRegister.video.hash;
                    } else {
                        if (JSON.parse(sessionStorage.getItem("carousel")).hash) {
                            hash_code = JSON.parse(sessionStorage.getItem("carousel")).hash;
                        }
                    }
                    if (hash_code === hash(carouselRegister.slides())) {
                        campaign.carousel_ads = JSON.stringify(carouselRegister.get().url);
                    }
                }
            } catch (e) { }

            //SET VIDEO
            try {
                if (cart.admin_video && cart.admin_video_thumbnail) {
                    try {
                        campaign.video = JSON.stringify({ url: cart.admin_video, thumbnail: cart.admin_video_thumbnail });
                    } catch (e) {
                    }
                } else {
                    let hash_code = null;
                    if (videoRegister.video.hash) {
                        hash_code = videoRegister.video.hash;
                    } else {
                        if (JSON.parse(sessionStorage.getItem("video")).hash) {
                            hash_code = JSON.parse(sessionStorage.getItem("video")).hash;
                        }
                    }
                    if (hash_code === hash(videoRegister.slides())) {
                        campaign.video = JSON.stringify({
                            url: videoRegister.get().url,
                            thumbnail: videoRegister.get().thumbnail
                        });
                    }
                }
            } catch (e) {
            }

            //SET CANVAS
            try {
                campaign.image = {
                    "fb": { "feed": null },
                    "instagram": { "feed": null }
                };
                if (canvasRegister.get("facebook")) {
                    campaign.image.fb.feed = canvasRegister.get("facebook").url;
                }
                if (canvasRegister.get("instagram")) {
                    campaign.image.instagram.feed = canvasRegister.get("instagram").url;
                }
                campaign.image = JSON.stringify(campaign.image);

            } catch (e) {

                //FALLBACK
                if (cart.admin_image) {
                    if (this.state.admin_image_file) {
                        campaign.file = this.state.admin_image_file;
                    } else {
                        //campaign.file = this.functions.dataURItoBlob(cart.admin_image.data_url)
                    }
                }

            }

            //SET KEYWORD_LANGUAGES
            try {
                let langs = {
                    google: cart.keyword_languages,
                    bing: cart.keyword_languages
                };
                campaign.additional_keyword_languages = JSON.stringify(langs);
            } catch (e) {
            }

            //SET REGIONS
            if (cart.regions) {
                campaign.region = {};
                for (let i = 0; i < cart.regions.length; i++) {
                    campaign.region[i] = cart.regions[i].id;
                }
            }

            //SET DISPLAY REGION
            try {
                if (flowRegister.getValue("display_region")) {
                    campaign.ad_region = flowRegister.getValue("display_region");
                }
            } catch (e) {
            }

            //SET LONGTAIL REGIONS
            try {
                if (flowRegister.getValue("longtail_regions")) {
                    campaign.longtail_region = flowRegister.getValue("longtail_regions");
                }
            } catch (e) {
            }

            campaign.landing_extra = {};

            try {
                if (blurRegister.get()) {
                    campaign.landing_extra.blur_image = blurRegister.get();
                }
            } catch (e) { }

            if (salesChannelRegister.get("name") === "yieldlock") {

                campaign.landing_extra.yieldlock = {};

                if (collectedRegister.getValue('google')) {
                    let google = collectedRegister.getValue('google');
                    if (typeof google === 'object' && google.autocomplete_lat && google.autocomplete_lng) {
                        campaign.landing_extra.yieldlock.lat = google.autocomplete_lat;
                        campaign.landing_extra.yieldlock.lng = google.autocomplete_lng;
                    }
                }

                if (collectedRegister.getValue('amenities')) {
                    let amenities = collectedRegister.getValue('amenities');
                    if (Array.isArray(amenities)) {
                        campaign.landing_extra.yieldlock.amenities = amenities.filter((item) => {
                            return item.selected
                        }).map((item) => {
                            return item.title
                        });
                    }
                }

                if (collectedRegister.getValue('bed')) {
                    let beds = JSON.parse(collectedRegister.getValue('bed'));
                    if (typeof beds === 'object' && beds.amount) {
                        campaign.landing_extra.yieldlock.beds = beds.amount;
                    }
                }

                if (collectedRegister.getValue('status')) {
                    let status = JSON.parse(collectedRegister.getValue('status'));
                    if (typeof status === 'object' && status.title) {
                        campaign.landing_extra.yieldlock.property_status = status.title;
                    }
                }

                if (collectedRegister.getValue('bath')) {
                    let baths = JSON.parse(collectedRegister.getValue('bath'));
                    if (typeof baths === 'object' && baths.amount) {
                        campaign.landing_extra.yieldlock.baths = baths.amount;
                    }
                }

                if (collectedRegister.getValue('size')) {
                    let size = JSON.parse(collectedRegister.getValue('size'));
                    if (size) {
                        campaign.landing_extra.yieldlock.sqft = size;
                    }
                }

                if (imagesRegister.get()) {
                    let images = imagesRegister.get();
                    if (Array.isArray(images) && images.length > 0) {
                        let image = null;
                        if (typeof images[0] === "string") {
                            image = images[0];
                        } else if (typeof images[0] === "object") {
                            image = images[0].original;
                        }
                        if (image) {
                            campaign.landing_extra.yieldlock.image = image;
                        }
                    }
                }

                if (yieldlockRegister.getValue('market_price')) {
                    campaign.landing_extra.yieldlock.market_price = yieldlockRegister.getValue('market_price');
                }

                if (yieldlockRegister.getValue('market_rent')) {
                    campaign.landing_extra.yieldlock.market_rent = yieldlockRegister.getValue('market_rent');
                }

                if (yieldlockRegister.getValue('rent_boost')) {
                    campaign.landing_extra.yieldlock.rent_boost = yieldlockRegister.getValue('rent_boost');
                }

                if (yieldlockRegister.getValue('years')) {
                    let years = JSON.parse(yieldlockRegister.getValue('years'));
                    campaign.landing_extra.yieldlock.years = years.years;
                }

                if (yieldlockRegister.getValue('yield')) {
                    campaign.landing_extra.yieldlock.yield = yieldlockRegister.getValue('yield');
                }

                if (yieldlockRegister.getValue('up_front')) {
                    campaign.landing_extra.yieldlock.upfront = yieldlockRegister.getValue('up_front');
                } else {
                    campaign.landing_extra.yieldlock.upfront = false;
                }

                if (yieldlockRegister.getValue('tabs')) {
                    let tabs = yieldlockRegister.getValue('tabs');
                    campaign.landing_extra.yieldlock.type = tabs.id;
                }

                if (yieldlockRegister.getValue('list_price')) {
                    campaign.landing_extra.yieldlock.list_price = yieldlockRegister.getValue('list_price');
                }

                if (collectedRegister.getValue('base_currency')) {
                    campaign.landing_extra.yieldlock.currency = collectedRegister.getValue('base_currency');
                }

                let theme = themeRegister.getValue();

                if (typeof theme === 'object' && theme.first_title) {
                    campaign.landing_extra.yieldlock.industry = theme.first_title;
                }

                if (typeof theme === 'object' && theme.first_subtitle_long) {
                    campaign.landing_extra.yieldlock.location = theme.first_subtitle_long;
                }

            }

            if (this.state.landingpage) {

                //PLUGINS
                try {
                    campaign.landing_extra.plugins = {};
                    campaign.landing_extra.plugins.extraservices = this.state.plugin_extraservices;
                    campaign.landing_extra.plugins.conveyancing = this.state.plugin_conveyancing;
                    campaign.landing_extra.plugins.listings = this.state.plugin_listings;
                    campaign.landing_extra.plugins.agency_listings = this.state.plugin_agency_listings;
                    campaign.landing_extra.plugins.plugin_leadform_earlyaccess = this.state.plugin_leadform_earlyaccess;
                    campaign.landing_extra.plugins.plugin_leadform_moreinfo = this.state.plugin_leadform_moreinfo;
                    campaign.landing_extra.plugins.plugin_leadform_viewing = this.state.plugin_leadform_viewing;
                    campaign.landing_extra.plugins.plugin_leadform_callback = this.state.plugin_leadform_callback;
                    campaign.landing_extra.plugins.image_blocker = this.state.plugin_image_blocker;
                    campaign.landing_extra.plugins.prequalify = this.state.plugin_prequalify;
                } catch (e) {
                }

                //FIRST LOCATION
                try {
                    let region = collectedRegister.getValue("region");
                    campaign.landing_extra.location = region.name; //cart.display_region ? JSON.stringify(cart.display_region) : null;
                } catch (e) {
                }

                //ADS CURRENCY
                try {
                    let currency = collectedRegister.getValue("currency");
                    if (currency) {
                        campaign.landing_extra.currency_ads = JSON.parse(currency).title;
                    }
                } catch (e) {
                }

                //IDENTIFIER
                try {
                    let industry_type = flowRegister.getValue("industry_type");
                    campaign.landing_extra.identifier = industry_type;//scraper_data.additional_information.facts.listing_type.indentifier ? scraper_data.additional_information.facts.listing_type.indentifier : 'buy';
                } catch (e) {
                }

                //FURNITURE
                try {
                    let furnishings = collectedRegister.getValue("furnishings");
                    campaign.landing_extra.furnishings = JSON.parse(furnishings).title; //scraper_data.additional_information.facts.furnishings.title ? scraper_data.additional_information.facts.furnishings.title : null;
                } catch (e) {
                }

                //DURATION
                try {
                    let duration = collectedRegister.getValue("duration");
                    campaign.landing_extra.duration = JSON.parse(duration).title; //scraper_data.additional_information.facts.duration.title ? scraper_data.additional_information.facts.duration.title : null;
                } catch (e) {
                }

                //INDUSTRY
                try {
                    campaign.landing_extra.industry = cart.industry ? cart.industry.name : null;
                } catch (e) {
                    campaign.landing_extra.industry = null;
                }

                //PRICE
                try {
                    let price = collectedRegister.getValue("price");
                    campaign.landing_extra.price = JSON.parse(price);  //scraper_data.additional_information.facts.price ? scraper_data.additional_information.facts.price : null;
                } catch (e) {
                    campaign.landing_extra.price = null;
                }

                //BASE CURRENCY
                try {
                    let base_currency = collectedRegister.getValue("base_currency");
                    campaign.landing_extra.currency = base_currency; //scraper_data.additional_information.facts.currency ? scraper_data.additional_information.facts.currency : null;
                } catch (e) {
                    campaign.landing_extra.currency = null;
                }

                //AD CURRENCY
                try {
                    let currency = JSON.parse(collectedRegister.getValue("currency"));
                    campaign.landing_extra.ad_currency = currency.title;
                } catch (e) {
                    campaign.landing_extra.ad_currency = null;
                }

                //BATHROOMS
                try {
                    let bath = collectedRegister.getValue("bath");
                    campaign.landing_extra.baths = JSON.parse(bath).amount; //scraper_data.additional_information.facts.bathrooms ? scraper_data.additional_information.facts.bathrooms : null;
                } catch (e) {
                    campaign.landing_extra.baths = null;
                }

                //BEDROOMS
                try {
                    let bed = collectedRegister.getValue("bed");
                    campaign.landing_extra.beds = JSON.parse(bed).amount; //scraper_data.additional_information.facts.bedrooms ? scraper_data.additional_information.facts.bedrooms : null;
                } catch (e) {
                    campaign.landing_extra.beds = null;
                }

                //AREA
                try {
                    let size = collectedRegister.getValue("size");
                    campaign.landing_extra.area_sqft = size; //scraper_data.additional_information.facts.area_sqft ? scraper_data.additional_information.facts.area_sqft : null;
                } catch (e) {
                    campaign.landing_extra.area_sqft = null;
                }

                //COMPLETION STATUS
                try {
                    let status = collectedRegister.getValue("status");
                    campaign.landing_extra.completion_status = JSON.parse(status).title; //scraper_data.additional_information.facts.completion_status.title ? scraper_data.additional_information.facts.completion_status.title : null;
                } catch (e) {
                    campaign.landing_extra.completion_status = null;
                }

                //WEB TOUR
                try {
                    let web_tour = collectedRegister.getValue("web_tour");
                    campaign.landing_extra.web_tour = web_tour ? web_tour : null;
                } catch (e) {
                    campaign.landing_extra.web_tour = null;
                }

                //DESCRIPTION
                try {
                    let description = collectedRegister.getValue("description");
                    campaign.landing_extra.description = description ? description : null;
                } catch (e) {
                    campaign.landing_extra.description = null;
                }

                campaign.landing_extra.broker = {};

                //BROKER NAME
                try {
                    campaign.landing_extra.broker.name = this.state.broker_name ? this.state.broker_name : null;
                } catch (e) {
                    campaign.landing_extra.broker.name = null;
                }

                //BROKER COMPANY
                try {
                    campaign.landing_extra.broker.company = this.state.broker_company ? this.state.broker_company : null;
                } catch (e) {
                    campaign.landing_extra.broker.company = null;
                }

                //BROKER #BRN
                try {
                    campaign.landing_extra.broker.brn = this.state.broker_brn ? this.state.broker_brn : null;
                } catch (e) {
                    campaign.landing_extra.broker.brn = null;
                }

                //BROKER TRAKHEESI
                try {
                    campaign.landing_extra.broker.trakheesi = this.state.broker_trakheesi ? this.state.broker_trakheesi : null;
                } catch (e) {
                    campaign.landing_extra.broker.trakheesi = null;
                }

                //BROKER REF
                try {
                    campaign.landing_extra.broker.ref = this.state.broker_ref ? this.state.broker_ref : null;
                } catch (e) {
                    campaign.landing_extra.broker.ref = null;
                }

                //BROKER EMAIL
                try {
                    campaign.landing_extra.broker.email = this.state.landing_email ? this.state.landing_email : null;
                } catch (e) {
                    campaign.landing_extra.broker.email = null;
                }

                //BROKER WHATSAPP
                try {
                    campaign.landing_extra.broker.whatsapp = this.state.whatsapp;
                } catch (e) {
                    campaign.landing_extra.broker.whatsapp = false;
                }

                //BROKER PHONE
                try {
                    campaign.landing_extra.broker.phone = (this.state.country.dialCode && this.state.phone !== "") ? (this.state.country.dialCode + this.state.phone) : this.state.phone;
                } catch (e) {
                    campaign.landing_extra.broker.phone = null;
                }

                //BROKER ANALYTICS
                try {
                    campaign.landing_extra.broker.ga_id_branding = this.state.ga_id_branding;
                } catch (e) {
                    campaign.landing_extra.broker.ga_id_branding = null;
                }

                //BROKER ANALYTICS 4
                try {
                    campaign.landing_extra.broker.ga4_id_branding = this.state.ga4_id_branding;
                } catch (e) {
                    campaign.landing_extra.broker.ga4_id_branding = null;
                }

                //BROKER FACEBOOK PIXEL
                try {
                    campaign.landing_extra.broker.fb_id_branding = this.state.fb_id_branding;
                } catch (e) {
                    campaign.landing_extra.broker.fb_id_branding = null;
                }

                //BROKER TIKTOK PIXEL
                try {
                    campaign.landing_extra.broker.tiktok_id_branding = this.state.tiktok_id_branding;
                } catch (e) {
                    campaign.landing_extra.broker.tiktok_id_branding = null;
                }

                //BROKER SNAPCHAT PIXEL
                try {
                    campaign.landing_extra.broker.snapchat_id_branding = this.state.snapchat_id_branding;
                } catch (e) {
                    campaign.landing_extra.broker.snapchat_id_branding = null;
                }

                //EXTRAS
                try {
                    campaign.landing_extra.extras = [];
                    if (scraper_data.additional_information.facts.cheques) {
                        campaign.landing_extra.extras.push(scraper_data.additional_information.facts.cheques.title)
                    }
                    if (scraper_data.additional_information.facts.freemonths) {
                        campaign.landing_extra.extras.push(scraper_data.additional_information.facts.freemonths.title)
                    }
                    if (scraper_data.additional_information.facts.discount) {
                        campaign.landing_extra.extras.push(scraper_data.additional_information.facts.discount.title)
                    }
                    if (scraper_data.additional_information.facts.dldwaiver) {
                        campaign.landing_extra.extras.push(scraper_data.additional_information.facts.dldwaiver.title)
                    }
                    if (scraper_data.additional_information.facts.downpayment) {
                        campaign.landing_extra.extras.push(scraper_data.additional_information.facts.downpayment.title)
                    }
                    if (scraper_data.additional_information.facts.finance) {
                        campaign.landing_extra.extras.push(scraper_data.additional_information.facts.finance.title)
                    }
                    if (scraper_data.additional_information.facts.paymentplan) {
                        campaign.landing_extra.extras.push(scraper_data.additional_information.facts.paymentplan.title)
                    }
                    if (scraper_data.additional_information.facts.servicecharge) {
                        campaign.landing_extra.extras.push(scraper_data.additional_information.facts.servicecharge.title)
                    }
                    if (scraper_data.additional_information.facts.roi) {
                        campaign.landing_extra.extras.push(scraper_data.additional_information.facts.roi.title)
                    }
                } catch (e) {
                    campaign.landing_extra.extras = null;
                }

                //BROKER IMAGE
                try {
                    campaign.landing_extra.landingpage_profile_image = this.state.broker_image;
                } catch (e) {
                    campaign.landing_extra.landingpage_profile_image = null;
                }

                //BROKER LOGO
                try {
                    campaign.landing_extra.landingpage_logo_image = this.state.broker_logo;
                } catch (e) {
                    campaign.landing_extra.landingpage_logo_image = null;
                }

                //BROKER FAVICON
                try {
                    let user = userRegister.getUser();
                    if (user && user.branding_pref && user.favicon_image) {
                        campaign.landing_extra.landingpage_favicon_image = user.favicon_image;
                    }
                } catch (e) {
                    campaign.landing_extra.landingpage_favicon_image = null;
                }

                //BROKER QR CODE
                try {
                    campaign.landing_extra.landingpage_qrcode_image = this.state.broker_qrcode;
                } catch (e) {
                    campaign.landing_extra.landingpage_qrcode_image = null;
                }

                //BRANDING
                try {
                    campaign.landing_extra.branding_pref = [];
                    if (this.state.branding_pref.primary_color) {
                        campaign.landing_extra.branding_pref.push(this.state.branding_pref.primary_color)
                    }
                    if (this.state.branding_pref.secondary_color) {
                        campaign.landing_extra.branding_pref.push(this.state.branding_pref.secondary_color)
                    }
                } catch (e) {
                    campaign.landing_extra.branding_pref = null;
                }

                //CUSTOM CREATIVE
                try {
                    if (collectedRegister.getValue("custom_creative")) {
                        campaign.landing_extra.custom_creative = collectedRegister.getValue("custom_creative");
                    }
                } catch (e) {
                }

                //THEME
                try {
                    let theme_id = themeRegister.getTheme();
                    campaign.landing_extra.theme = theme_id;
                } catch (e) {
                }

                //DRAFT
                try {
                    if (!collectedRegister.getValue("draft")){
                        campaign.landing_extra.draft_exist = "false";
                    }
                } catch (e) {
                }

                //AMENITIES
                try {
                    let amenities = collectedRegister.getValue("amenities");
                    campaign.landing_extra.amenities = amenities.filter((item) => {
                        return item.selected
                    }).map((item) => {
                        return item.title
                    });
                } catch (e) {
                }

                //IMAGES
                try {
                    if (imagesRegister.get()) {
                        let images = imagesRegister.get();
                        if (Array.isArray(images) && images.length > 0) {

                            let images_to_add = [];
                            images.map((item) => {
                                images_to_add.push(item.original);
                            });

                            let stored_data = cartRegister.get();
                            if (stored_data.admin_image && stored_data.admin_image.original) {
                                images_to_add = images_to_add.filter((item) => { return item !== stored_data.admin_image.original });
                                images_to_add.unshift(stored_data.admin_image.original);
                            }

                            images_to_add.map((item, i) => {
                                campaign.landing_extra['image' + i] = item;
                            });
                        }
                    }
                } catch (e) {
                }

                console.log(campaign);

                //SLOGANS
                try {
                    campaign.slogans = (JSON.stringify(Object.keys(cart.quotes).filter((key) => {
                        return cart.quotes[key].selected
                    }).sort(function (a, b) {
                        if (cart.quotes[a].index < cart.quotes[b].index) {
                            return -1;
                        }
                        if (cart.quotes[a].index > cart.quotes[b].index) {
                            return 1;
                        }
                        return 0;
                    }).map((key) => {
                        return cart.quotes[key].slogan
                    })))
                } catch (e) {
                    campaign.slogans = null;
                }

            }

            //IDENTIFIER
            let identifier = null;
            try {
                identifier = collectedRegister.getValue("listing_type");
                identifier = identifier.indentifier;
            } catch (e) {
                identifier = null;
            }

            //IDENTIFIER
            let saleschannel = "propertybooster";
            try {
                if (window.location.hostname.indexOf('propertybooster') !== -1) {
                    saleschannel = "propertybooster";
                } else if (window.location.hostname.indexOf('boostabostad') !== -1) {
                    saleschannel = "boostabostad";
                } else if (window.location.hostname.indexOf('yieldlock') !== -1) {
                    saleschannel = "yieldlock";
                }
            } catch (error) { }

            //BRANDING CLIENT
            let branding = false;
            try {
                let user = userRegister.getUser();
                if (user.socialData && user.socialData.feeds) {
                    branding = true;
                }
            } catch (error) { }

            //URL
            let url_system = "app.devsaleschannel.com";
            try {
                if (window.location.hostname.indexOf("localhost") == -1) {
                    url_system = window.location.hostname;
                }
            } catch (error) { }

            //PRICE
            let data_price = 0;
            try{
                if((/^-?\d+$/.test(campaign.landing_extra.price))){
                    data_price = campaign.landing_extra.price;
                }
            }catch(error){}

            let duration = null;
            try {
                duration = collectedRegister.getValue("duration");
                duration = JSON.parse(duration).id;
            } catch (e) {
                duration = 0;
            }

            // SET FEED DATA
            try {
                if (canvasRegister.get("instagram") && canvasRegister.get("instagram").url) {
                    let feed_data = {
                        "branding": branding,
                        "saleschannel": saleschannel,
                        "lat": this.state.lat,
                        "lng": this.state.lng,
                        "image": canvasRegister.get("instagram").url,
                        "website": 'https://' + url_system.replace("app.", "lp."),
                        "live": window.location.hostname.indexOf('dev') === -1 && window.location.hostname.indexOf('localhost') === -1,
                        "industry": cart.industry.name,
                        "sold": false,
                        "identifier": identifier,
                        "price": data_price,
                        "currency": campaign.landing_extra.currency,
                        "furnishings": campaign.landing_extra.furnishings,
                        "beds": campaign.landing_extra.beds,
                        "baths": campaign.landing_extra.baths,
                        "area_sqft": campaign.landing_extra.area_sqft,
                        "amenities": campaign.landing_extra.amenities,
                        "duration": duration,
                        //"slogans": campaign.slogans,
                        "address": this.state.feed_address,
                        "city": this.state.feed_city,
                        "region": this.state.feed_region,
                        "country": this.state.feed_country,
                        "neighborhood": this.state.feed_neighborhood,
                    };
                    campaign.landing_extra.feed_data = feed_data;
                    console.log(feed_data);
                }
            } catch (error) { }

            //CONVERSION STRATEGY
            if (this.state.show_strategy /*&& this.state.inhouse*/) {
                try {
                    let conversion_data = {};
                    let user = userRegister.getUser();
                    let strategy = JSON.parse(this.state.strategy.value);
                    if (strategy.id === 1) {
                        conversion_data = {
                            campaign: { objective: "OUTCOME_TRAFFIC", bid_strategy: "LOWEST_COST_WITHOUT_CAP" },
                            adset: {
                                optimization_goal: "LANDING_PAGE_VIEWS",
                                billing_event: "IMPRESSIONS",
                                //promoted_object: { pixel_id: null }
                            }
                        }
                        //conversion_data.adset.promoted_object.pixel_id = user.socialData.fb_id_fallback;
                    } else if (strategy.id === 2) {
                        conversion_data = {
                            campaign: { objective: "OUTCOME_SALES", bid_strategy: "LOWEST_COST_WITHOUT_CAP" },
                            adset: {
                                optimization_goal: "OFFSITE_CONVERSIONS",
                                billing_event: "IMPRESSIONS",
                                promoted_object: { pixel_id: null, custom_event_type: "PURCHASE", event_id: null }
                            }
                        };
                        conversion_data.adset.promoted_object.pixel_id = user.socialData.fb_id_fallback;
                    }

                    //ADD TO LANDING EXTRA
                    campaign.landing_extra.conversion_data = conversion_data;

                } catch (error) {
                    console.log(error);
                }
            }

            //"https://transparentpresence.com/propertybooster/create-slides"
            //"/https://transparentpresence.com/propertybooster/create-video"
            // SET CREATIVE DATA
            try {
                let creative_data = {
                    video: { slides: videoRegister.slides() },
                    carousel: { slides: carouselRegister.slides() }
                };
                campaign.landing_extra.creative_data = creative_data;
                console.log(creative_data);
            } catch (error) { }

            campaign.landing_extra = JSON.stringify(campaign.landing_extra);

            campaign.free_website = this.state.landingpage;

            if (langRegister.lang()) {
                campaign.lang = langRegister.lang();
            }
            if (cart.duration) {
                campaign.campaign_duration = cart.duration;
            }
            if (campaign.free_website) {
                campaign.free_website_data = {};
            }
            if (cart.age_range || cart.targets || cart.interests || cart.behaviors) {
                campaign.facebook_demographics = {};
            }
            if (this.state.company_name) {
                campaign.advertise_name = this.state.company_name;
            }
            if (this.state.own_url) {
                campaign.advertise_website = this.state.own_website;
            } else if (this.state.portal_url) {
                campaign.advertise_website = this.state.website;
            }
            if (this.state.pay_now) {
                campaign.card_token = token;
            }
            if (cart.industry) {
                campaign.industry = cart.industry.id;
            }
            if (this.state.phone) {
                let country_code = null;
                try {
                    country_code = this.state.country.dialCode;
                } catch (e) {
                }
                //*OVERRIDE PHONE* Do not send phone with campaign if origin region is different from market
                if (this._disablePhoneCheck()) {
                    campaign.advertise_phone = "";
                } else {
                    campaign.advertise_phone = this.state.phone;
                    if (country_code) {
                        campaign.advertise_phone = country_code + campaign.advertise_phone;
                    }
                }
            }

            if (cart.image && !cart.admin_image) {
                campaign.image_id = cart.image.id
            }
            if (cart.channels && cart.budget) {
                campaign.offer = {};
                campaign.channels = {};
                for (let key in cart.budget) {
                    if (cart.budget[key] && cart.channels[key].selected) {
                        if (key === "facebook") {
                            campaign.offer["fb"] = { cpc: cart.budget[key].cpc, cpi: cart.budget[key].cpi };
                            campaign.channels["fb"] = cart.budget[key].spend;
                        } else {
                            campaign.offer[key] = { cpc: cart.budget[key].cpc, cpi: cart.budget[key].cpi };
                            campaign.channels[key] = cart.budget[key].spend;
                        }
                    }
                }
            }
            if (cart.target_slogans) {
                campaign.target = {};
                for (let i = 0; i < cart.target_slogans.length; i++) {
                    if (cart.target_slogans[i].selected) {
                        //campaign.target[cart.target_slogans[i].id] = cart.target_slogans[i].id;
                        campaign.target_slogan = cart.target_slogans[i].id;
                    }
                }
            }
            if (cart.quotes && !cart.admin_quotes) {
                //CHECK IF CUSTOM QUOTE
                let custom_exist = false;
                for (var key in cart.quotes) {
                    if (cart.quotes[key].custom) {
                        custom_exist = true;
                        break;
                    }
                }

                if (collectedRegister.getValue("draft")) {
                //patch for draft campaigns or custom_slogan object from draft will be preserved and disrupt confirmation and report
                    try {
                        campaign.custom_slogans = [];
                        var sortable = [];
                        for (var key in cart.quotes) {
                            sortable.push([cart.quotes[key], cart.quotes[key].index]);
                        }
                        sortable.sort(function (a, b) {
                            return a[1] - b[1];
                        });
                        sortable.map((item) => {
                            campaign.custom_slogans.push(item[0].slogan);
                        });
                    } catch (e) {
                        campaign.custom_slogans = null;
                    }
                } else {
                    if (custom_exist) {
                        campaign.custom_slogans = [];
                        var sortable = [];
                        for (var key in cart.quotes) {
                            sortable.push([cart.quotes[key], cart.quotes[key].index]);
                        }
                        sortable.sort(function (a, b) {
                            return a[1] - b[1];
                        });
                        sortable.map((item) => {
                            campaign.custom_slogans.push(item[0].slogan);
                        });
                    } else {
                        campaign.slogans = {};
                        let index = 0;
                        var sortable = [];
                        for (var key in cart.quotes) {
                            sortable.push([cart.quotes[key], cart.quotes[key].index]);
                        }
                        sortable.sort(function (a, b) {
                            return a[1] - b[1];
                        });
                        sortable.map((item) => {
                            campaign.slogans[index] = item[0].id;
                            index++;
                        });
                    }
                }

            } else {
                campaign.custom_ad_text = cart.admin_quotes.text;
                delete campaign.slogans;
            }
            if (campaign.free_website) {
                campaign.free_website_data.email = this.state.landing_email;
                campaign.free_website_data.address = this.state.landing_address;
                campaign.free_website_data.lat = this.state.lat;
                campaign.free_website_data.lng = this.state.lng;
                campaign.free_website_data.whatsapp = this.state.whatsapp;
            }
            if (cart.age_range) {
                let age_range = cart.age_range.sort(function (a, b) {
                    return a - b
                });
                if (age_range[0]) {
                    campaign.facebook_demographics.age_min = age_range[0];
                }
                if (age_range[1]) {
                    campaign.facebook_demographics.age_max = age_range[1];
                }
            }
            if (cart.targets) {
                let targets = cart.targets.filter((item) => {
                    return item.selected
                });
                if (targets.length > 0 && targets.length < 2) {
                    campaign.facebook_demographics.gender = targets[0].value;
                }
            }
            if (cart.interests) {
                try {
                    if (cart.interests.length > 0) {
                        campaign.facebook_demographics.interests = cart.interests;
                    }
                } catch (e) {
                }
            }
            if (cart.behaviors) {
                try {
                    if (cart.behaviors.length > 0) {
                        campaign.facebook_demographics.behaviors = cart.behaviors;
                    }
                } catch (e) {
                }
            }
            if (cart.related_industries || cart.selected_industries) {
                campaign.related_industries = {};
                let related_industries = [];
                if (cart.selected_industries) {
                    related_industries = related_industries.concat(cart.selected_industries);
                }
                for (let i = 0; i < related_industries.length; i++) {
                    campaign.related_industries[i] = related_industries[i].id;
                }
                campaign.related_industries = JSON.stringify(campaign.related_industries);
            }
            if (cart.lockin && cart.lockin_plan) {
                campaign.lock_in = cart.lockin_plan.months;
                campaign.free_months = cart.lockin_plan.free_months;
            }
            if (this.state.redirect) {
                campaign.email = this.state.redirect_email;
            }
            if (cart.options) {
                campaign.optimization = (cart.options === "instant" ? 2 : 1);
            }
            campaign.region = JSON.stringify(campaign.region);
            campaign.channels = JSON.stringify(campaign.channels);
            campaign.offer = JSON.stringify(campaign.offer);
            if (campaign.slogans) {
                campaign.slogans = JSON.stringify(campaign.slogans);
            }
            if (campaign.custom_slogans) {
                campaign.custom_slogans = JSON.stringify(campaign.custom_slogans);
            }
            if (campaign.target) {
                campaign.target = JSON.stringify(campaign.target);
            }
            if (campaign.free_website) {
                campaign.free_website_data = JSON.stringify(campaign.free_website_data);
            }
            if (campaign.facebook_demographics) {
                campaign.facebook_demographics = JSON.stringify(campaign.facebook_demographics);
            }

            if(collectedRegister.getValue("draft")){
                campaign.draft_id = collectedRegister.getValue("draft");
            }

            console.log(collectedRegister.getValue("draft"));
            console.log(campaign);

            return campaign;

        }
    };

    functions = {
        setLanding: () => {
            this.setState({ landingpage: !this.state.landingpage, website: "" });
        },
        createUser: () => {
            //CREATE USER OBJECT
            let user = { email: this.state.email, password: this.state.password, lang: langRegister.lang() };
            //CALL API TO CREATE USER
            dataRegister.signUp(salesChannelRegister.get("market"), user).then((response) => {
                if (!response.errors) {
                    //UPDATE USER DATA
                    userRegister.set(response);
                    this.update.user();
                    //CHECK IF PAY NOW SELECTED
                    if (this.state.pay_now) {
                        this.functions.createCampaignPay();
                    } else {
                        this.functions.createCampaignNoPay();
                    }
                } else {
                    //SIGNUP ERROR
                    this.setState({ isLoading: false }, () => {
                        console.log(response.errors)
                    });
                }
            }, (error) => {
                //CREATE USER SIGNUP API ERROR
                this.setState({ system_error: true, isLoading: false }, () => {
                    console.log(error);
                });
            });
        },
        createCampaignPay: (value) => {
            //CALL API TO CREATE CAMPAIGN
            dataRegister.campaign(salesChannelRegister.get('market'), value).then((data) => {
                if (!data.errors) {
                    //SET CAMPAIGN DATA AND GO TO CONFIRMATION
                    campaignRegister.set(data);
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/confirmation");

                } else {
                    //CREATE CAMPAIGN VALUES ERROR
                    this.setState({ isLoading: false }, () => {
                        console.log(data.errors);
                    });
                }
            }, (error) => {
                //CREATE CAMPAIGN API ERROR
                if (error.status === 401) {
                    this.setState({ isLoading: false, error: 401 }, () => {
                        console.log(error);
                    });
                } else {
                    this.setState({ isLoading: false, system_error: true }, () => {
                        console.log(error);
                    });
                }
            });
        },
        createCampaignNoPay: () => {
            //ADD TO FORMDATA
            let campaign = this.update.campaign();
            const formData = new FormData();
            for (let key in campaign) {
                formData.append(key, campaign[key]);
            }
            dataRegister.campaign(salesChannelRegister.get('market'), formData).then((data) => {
                if (!data.errors) {
                    data.no_pay = true;
                    campaignRegister.set(data);
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/confirmation")
                } else {
                    this.setState({ isLoading: false });
                }
            }, (error) => {
                //CREATE CAMPAIGN API ERROR
                if (error.status === 401) {
                    this.setState({ isLoading: false, error: 401 }, () => {
                        console.log(error);
                    });
                } else {
                    this.setState({ isLoading: false, system_error: true }, () => {
                        console.log(error);
                    });
                }
            });
        },
        reviewLanding: () => {

            let cart = JSON.parse(JSON.stringify(cartRegister.get()));
            let scraper_data = JSON.parse(scraperRegister.get());
            let landing_data = {};

            console.log(scraper_data);
            console.log(cart);

            try {
                if (this.state.preview_slideshow) {
                    landing_data.preview_slideshow = "true";
                }
            } catch (e) {
            }

            try {
                if (this.state.company_name) {
                    landing_data.website_advertiser = this.state.company_name;
                }
            } catch (e) {
            }

            try {
                if (canvasRegister.get("instagram")) {
                    landing_data.preview_canvas = canvasRegister.get("instagram").url;
                }
                } catch (e) {
            }

            try {

                if (cart.admin_video && cart.admin_video_thumbnail) {
                    try {
                        landing_data.video = cart.admin_video;
                    } catch (e) {
                    }
                } else {
                    if (videoRegister.get().url) {
                        landing_data.video = videoRegister.get().url;
                    }
                }

            } catch (e) {
            }

            try {
                let theme_id = themeRegister.getTheme();
                landing_data.theme = theme_id;
            } catch (e) { }

            //BRANDING
            try {
                landing_data.branding_pref = [];
                if (this.state.branding_pref.primary_color) {
                    landing_data.branding_pref.push(this.state.branding_pref.primary_color)
                    //landing_data.branding = "true";
                }
                if (this.state.branding_pref.secondary_color) {
                    landing_data.branding_pref.push(this.state.branding_pref.secondary_color)
                }
                landing_data.branding_pref = JSON.stringify(landing_data.branding_pref);
            } catch (e) {
                landing_data.branding_pref = null;
            }
            try {
                if (this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s) {
                    landing_data.format_small = true;
                } else {
                    landing_data.format_small = false;
                }
            } catch (e) { }

            try {
                if (blurRegister.get()) {
                    landing_data.blur_image = blurRegister.get();
                }
            } catch (e) { }

            try {
                if (yieldlockRegister.getValue('market_price')) {
                    landing_data.market_price = yieldlockRegister.getValue('market_price');
                }
            } catch (e) { }

            try {
                if (yieldlockRegister.getValue('list_price')) {
                    landing_data.list_price = yieldlockRegister.getValue('list_price');
                }
            } catch (e) { }

            try {
                if (yieldlockRegister.getValue('up_front')) {
                    landing_data.upfront = yieldlockRegister.getValue('up_front');
                } else {
                    landing_data.upfront = false;
                }
            } catch (e) { }

            try {
                if (yieldlockRegister.getValue('yield')) {
                    landing_data.yield = yieldlockRegister.getValue('yield');
                }
            } catch (e) { }

            try {
                if (yieldlockRegister.getValue('years')) {
                    let years_value = yieldlockRegister.getValue('years');
                    years_value = JSON.parse(years_value);
                    landing_data.years = years_value.years;
                }
            } catch (e) { }

            //PLUGINS
            try {
                if (this.state.plugin_extraservices) {
                    landing_data.plugin_extraservices = this.state.plugin_extraservices;
                }
            } catch (e) {
            }
            //PLUGINS
            try {
                if (this.state.plugin_conveyancing) {
                    landing_data.plugin_conveyancing = this.state.plugin_conveyancing;
                }
            } catch (e) {
            }
            //PLUGINS
            try {
                if (this.state.plugin_listings) {
                    landing_data.plugin_listings = this.state.plugin_listings;
                }
            } catch (e) {
            }
            //PLUGINS
            try {
                if (this.state.plugin_agency_listings) {
                    landing_data.plugin_agency_listings = this.state.plugin_agency_listings;
                }
            } catch (e) {
            }
            //PLUGINS
            try {
                if (this.state.plugin_leadform_earlyaccess) {
                    landing_data.plugin_leadform_earlyaccess = this.state.plugin_leadform_earlyaccess;
                }
            } catch (e) {
            }
            //PLUGINS
            try {
                if (this.state.plugin_leadform_moreinfo) {
                    landing_data.plugin_leadform_moreinfo = this.state.plugin_leadform_moreinfo;
                }
            } catch (e) {
            }
            try {
                if (this.state.plugin_leadform_viewing) {
                    landing_data.plugin_leadform_viewing = this.state.plugin_leadform_viewing;
                }
            } catch (e) {
            }
            try {
                if (this.state.plugin_leadform_callback) {
                    landing_data.plugin_leadform_callback = this.state.plugin_leadform_callback;
                }
            } catch (e) {
            }
            //PLUGINS
            try {
                if (this.state.plugin_image_blocker) {
                    landing_data.image_blocker = this.state.plugin_image_blocker;
                }
            } catch (e) {
            }
            try {
                if (this.state.plugin_prequalify) {
                    landing_data.prequalify = this.state.plugin_prequalify;
                }
            } catch (e) {
            }
            //MARKET
            landing_data.market = salesChannelRegister.get('market');

            //FIRST LOCATION
            try {
                let region = collectedRegister.getValue("region");
                landing_data.first_location = region.name; //cart.display_region ? JSON.stringify(cart.display_region) : null;
            } catch (e) {
            }

            //IDENTIFIER
            try {
                let industry_type = flowRegister.getValue("industry_type");
                landing_data.identifier = industry_type;//scraper_data.additional_information.facts.listing_type.indentifier ? scraper_data.additional_information.facts.listing_type.indentifier : 'buy';
            } catch (e) {
            }

            //FURNISHINGS
            try {
                let furnishings = collectedRegister.getValue("furnishings");
                landing_data.furnishings = JSON.parse(furnishings).title; //scraper_data.additional_information.facts.furnishings.title ? scraper_data.additional_information.facts.furnishings.title : null;
            } catch (e) {
            }

            //DURATION
            try {
                let duration = collectedRegister.getValue("duration");
                landing_data.duration = JSON.parse(duration).title; //scraper_data.additional_information.facts.duration.title ? scraper_data.additional_information.facts.duration.title : null;
            } catch (e) {
            }

            //INDUSTRY
            try {
                landing_data.industry = cart.industry ? JSON.stringify(cart.industry) : null;
            } catch (e) {
                landing_data.industry = null;
            }

            //PRIVATE USER
            try {
                landing_data.private_user = this.state.private_user;
            } catch (e) {
            }

            //PRICE
            try {
                let price = collectedRegister.getValue("price");
                landing_data.price = JSON.parse(price);  //scraper_data.additional_information.facts.price ? scraper_data.additional_information.facts.price : null;
            } catch (e) {
                landing_data.price = null;
            }

            //BASE CURRENCY
            try {
                let base_currency = collectedRegister.getValue("base_currency");
                landing_data.currency = base_currency.toUpperCase(); //scraper_data.additional_information.facts.currency ? scraper_data.additional_information.facts.currency : null;
            } catch (e) {
                landing_data.currency = null;
            }

            //AD CURRENCY
            try {
                let currency = JSON.parse(collectedRegister.getValue("currency"));
                landing_data.currency_ads = currency.title.toUpperCase();
            } catch (e) {
                landing_data.currency_ads = null;
            }

            //BATHROOMS
            try {
                let bath = collectedRegister.getValue("bath");
                landing_data.baths = JSON.parse(bath).amount; //scraper_data.additional_information.facts.bathrooms ? scraper_data.additional_information.facts.bathrooms : null;
            } catch (e) {
                landing_data.baths = null;
            }

            //BEDROOMS
            try {
                let bed = collectedRegister.getValue("bed");
                landing_data.beds = JSON.parse(bed).amount; //scraper_data.additional_information.facts.bedrooms ? scraper_data.additional_information.facts.bedrooms : null;
            } catch (e) {
                landing_data.beds = null;
            }

            //AREA
            try {
                let size = collectedRegister.getValue("size");
                landing_data.area_sqft = size; //scraper_data.additional_information.facts.area_sqft ? scraper_data.additional_information.facts.area_sqft : null;
            } catch (e) {
                landing_data.area_sqft = null;
            }

            //COMPLETION STATUS
            try {
                let status = collectedRegister.getValue("status");
                landing_data.completion_status = JSON.parse(status).title; //scraper_data.additional_information.facts.completion_status.title ? scraper_data.additional_information.facts.completion_status.title : null;
            } catch (e) {
                landing_data.completion_status = null;
            }

            //DESCRIPTION
            try {
                let description = collectedRegister.getValue("description");
                landing_data.description = description ? description : null;
            } catch (e) {
                landing_data.description = null;
            }

            //LANG
            try {
                landing_data.lang = langRegister.lang();
            } catch (e) {

            }

            //EXTRAS
            try {
                landing_data.extras = [];
                if (scraper_data.additional_information.facts.cheques) {
                    landing_data.extras.push(scraper_data.additional_information.facts.cheques.title)
                }
                if (scraper_data.additional_information.facts.freemonths) {
                    landing_data.extras.push(scraper_data.additional_information.facts.freemonths.title)
                }
                if (scraper_data.additional_information.facts.discount) {
                    landing_data.extras.push(scraper_data.additional_information.facts.discount.title)
                }
                if (scraper_data.additional_information.facts.dldwaiver) {
                    landing_data.extras.push(scraper_data.additional_information.facts.dldwaiver.title)
                }
                if (scraper_data.additional_information.facts.downpayment) {
                    landing_data.extras.push(scraper_data.additional_information.facts.downpayment.title)
                }
                if (scraper_data.additional_information.facts.finance) {
                    landing_data.extras.push(scraper_data.additional_information.facts.finance.title)
                }
                if (scraper_data.additional_information.facts.paymentplan) {
                    landing_data.extras.push(scraper_data.additional_information.facts.paymentplan.title)
                }
                if (scraper_data.additional_information.facts.servicecharge) {
                    landing_data.extras.push(scraper_data.additional_information.facts.servicecharge.title)
                }
                if (scraper_data.additional_information.facts.roi) {
                    landing_data.extras.push(scraper_data.additional_information.facts.roi.title)
                }
                landing_data.extras = JSON.stringify(landing_data.extras);
            } catch (e) {
                landing_data.extras = null;
            }

            //BROKER NAME
            try {
                landing_data.broker_name = this.state.broker_name ? this.state.broker_name : null;
            } catch (e) {
                landing_data.broker_name = null;
            }

            //BROKER COMPANY
            try {
                landing_data.broker_company = this.state.broker_company ? this.state.broker_company : null;
            } catch (e) {
                landing_data.broker_company = null;
            }

            //BROKER #BRN
            try {
                landing_data.broker_brn = this.state.broker_brn ? this.state.broker_brn : null;
            } catch (e) {
                landing_data.broker_brn = null;
            }

            //BROKER TRAKHEESI
            try {
                landing_data.broker_trakheesi = this.state.broker_trakheesi ? this.state.broker_trakheesi : null;
            } catch (e) {
                landing_data.broker_trakheesi = null;
            }

            //BROKER REF
            try {
                landing_data.broker_ref = this.state.broker_ref ? this.state.broker_ref : null;
            } catch (e) {
                landing_data.broker_ref = null;
            }

            //BROKER EMAIL
            try {
                landing_data.broker_email = this.state.landing_email ? this.state.landing_email : null;
            } catch (e) {
                landing_data.broker_email = null;
            }

            //BROKER PHONE
            try {
                landing_data.broker_phone = (this.state.country.dialCode && this.state.phone !== "") ? (this.state.country.dialCode + this.state.phone) : this.state.phone;
            } catch (e) {
                landing_data.broker_phone = null;
            }

            //BROKER IMAGE
            try {
                if (this.validators.website(this.state.broker_image)) {
                    landing_data.broker_image = this.state.broker_image;
                    landing_data.broker_logo = this.state.broker_logo;
                }
            } catch (e) {
                //landing_data.broker_image = null;
            }

            //BROKER FAVICON
            try {
                let user = userRegister.getUser();
                if (user && user.branding_pref && user.favicon_image) {
                    landing_data.broker_favicon = user.favicon_image;
                }
            } catch (e) { }

            //BROKER QR CODE
            try {
                landing_data.broker_qrcode = this.state.broker_qrcode ? this.state.broker_qrcode : null;
            } catch (e) {
                landing_data.broker_qrcode = null;
            }

            //RESELLER ID – needed to fetch related correctly
            try {
                let user = userRegister.getUser();
                if (user && user.user_id) {
                    landing_data.reseller_id = user.user_id;
                }
            } catch (e) { }

            //WHATSAPP
            try {
                landing_data.broker_whatsapp = JSON.stringify(this.state.whatsapp);
            } catch (e) {
                landing_data.broker_whatsapp = false;
            }

            //ADDRESS
            try {
                let google = flowRegister.getValue("google");
                landing_data.address = google.autocomplete_full_address; //this.state.landing_address;
            } catch (e) {
                landing_data.address = false;
            }

            //LNG,LAT
            try {
                landing_data.lat = this.state.lat;
            } catch (e) {
                landing_data.lat = null;
            }
            try {
                landing_data.lng = this.state.lng;
            } catch (e) {
                landing_data.lng = null;
            }

            //AMENITIES
            try {
                let amenities = collectedRegister.getValue("amenities");
                landing_data.amenities = JSON.stringify(amenities.filter((item) => {
                    return item.selected
                }).map((item) => {
                    return item.title
                }));
            } catch (e) {
                landing_data.amenities = null;
            }

            //IMAGES
            try {
                let image_links = [];
                let images = imagesRegister.get();
                if (Array.isArray(images)) {
                    images.map((item) => {
                        image_links.push(item.original)
                    });
                    landing_data.images = image_links;
                }

                //ADD MAIN IMAGE FIRST
                let stored_data = cartRegister.get();
                if (stored_data.admin_image && stored_data.admin_image.original) {
                    landing_data.images = landing_data.images.filter((item) => { return item !== stored_data.admin_image.original });
                    landing_data.images.unshift(stored_data.admin_image.original);
                }

                landing_data.images = JSON.stringify(landing_data.images);

                /*
                landing_data.images = scraper_data.images.length > 0 ? scraper_data.images : null;
                if (landing_data.images) {
                    let first_image = null;
                    image_links = [];
                    for (let i = 0; i < landing_data.images.length; i++) {
                        if (landing_data.images[i].original === this.state.image.original) {
                            first_image = landing_data.images[i].original;
                        } else {
                            image_links.push(landing_data.images[i].original)
                        }
                    }
                    if (first_image) {
                        image_links.unshift(first_image);
                    }
                    landing_data.images = JSON.stringify(image_links);
                }

                 */
            } catch (e) {
                landing_data.images = [];
            }

            //SLOGANS
            try {
                landing_data.slogans = (JSON.stringify(Object.keys(cart.quotes).filter((key) => {
                    return cart.quotes[key].selected
                })
                    .sort(function (a, b) {
                        if (cart.quotes[a].index < cart.quotes[b].index) {
                            return -1;
                        }
                        if (cart.quotes[a].index > cart.quotes[b].index) {
                            return 1;
                        }
                        return 0;
                    }).map((key) => {
                        return cart.quotes[key].slogan
                    })))
            } catch (e) {
                landing_data.slogans = null;
            }

            //ALL DROPDOWNS

            console.log(landing_data);

            //ALL SLIDERS
            let query = queryString.stringify(landing_data);
            let url = "";
            if (window.location.hostname.indexOf("localhost") !== -1) {
                url = "http://localhost:3001/";
            } else {
                url = 'https://lp.' + dataRegister.domain;
            }

            var popUp = window.open(url + "?" + query, '_blank');
            try {
                let object = {
                    images: cart.uploaded_images ? cart.uploaded_images : null,
                    profile_image: landing_data.broker_image ? null : this.state.broker_image,
                    logo_image: landing_data.broker_logo ? null : this.state.broker_logo
                };

                if (object.images) {
                    try {
                        let first_image = null;
                        for (let i = 0; object.images.length; i++) {
                            if (this.state.image.date === object.images[i].date) {
                                first_image = object.images[i];
                                object.images.splice(i, 1);
                                break;
                            }
                        }
                        if (first_image) {
                            object.images.unshift(first_image);
                        }
                    } catch (e) {
                    }
                }

                setTimeout(() => {
                    popUp.postMessage(object, url);
                }, 500)
            } catch (e) {
                console.log(e);
            }

            /*let admin_slogan = [];
            if (cart.admin_quotes) {
                admin_slogan.push(cart.admin_quotes.text);
            }
            */
            //let extra_industries = cart.extra_industries ? cart.extra_industries : [];
            /*
            let url_object = {
                image: JSON.stringify({url: cart.image.url, id: cart.image.id}),
                company_name: this.state.company_name,
                address: this.state.landing_address,
                lang: langRegister.lang(),
                lat: this.state.lat,
                lng: this.state.lng,
                phone: (this.state.country.dialCode && this.state.phone !== "") ? (this.state.country.dialCode + this.state.phone) : this.state.phone,
                email: this.state.landing_email,
                industry: JSON.stringify(cart.industry),
                whatsapp: JSON.stringify(this.state.whatsapp),
                related_industries: JSON.stringify(cart.related_industries.filter((item) => {
                    return item.selected
                }).concat(extra_industries).map((item) => {
                    return (item)
                }).map((item) => {
                    return item.name
                })),
                slogans: !cart.admin_quotes ? (JSON.stringify(Object.keys(cart.quotes)
                    .filter((key) => {
                        return cart.quotes[key].selected
                    })
                    .sort(function (a, b) {
                        if (cart.quotes[a].index < cart.quotes[b].index) {
                            return -1;
                        }
                        if (cart.quotes[a].index > cart.quotes[b].index) {
                            return 1;
                        }
                        return 0;
                    }).map((key) => {
                        return cart.quotes[key].slogan
                    }))) : JSON.stringify(admin_slogan),
            };
            */
            //let query = queryString.stringify(url_object);
            //window.open("https://lp." + dataRegister.getDomain() + "?" + query, '_blank');
        },
        changeProfileImage: (e) => {
            try {
                if (e.target.files && e.target.files.length > 0) {
                    let files = new FormData();
                    files.append('image', e.target.files[0]);
                    dataRegister.analyzeImage(files).then((response) => {
                        if (response && response.images && response.images.small) {
                            this.setState({
                                broker_image: response.images.small
                            })
                        }
                    }, (error) => {

                    });
                }
            } catch (error) { }
        },
        changeQrCodeImage: (e) => {
            try {
                if (e.target.files && e.target.files.length > 0) {
                    let files = new FormData();
                    files.append('image', e.target.files[0]);
                    dataRegister.analyzeImage(files).then((response) => {
                        if (response && response.images && response.images.small) {
                            this.setState({
                                broker_qrcode: response.images.small
                            })
                        }
                    }, (error) => {

                    });
                }
            } catch (error) { }
        },
        getFileFromSrc: (src) => {
            return new Promise(function (resolve, reject) {
                try {
                    // Create an Image object
                    var img = new Image();
                    // Add CORS approval to prevent a tainted canvas
                    img.crossOrigin = 'Anonymous';
                    img.onload = function () {
                        // Create an html canvas element
                        var canvas = document.createElement('CANVAS');
                        // Create a 2d context
                        var ctx = canvas.getContext('2d');
                        var dataURL;
                        // Resize the canavas to the original image dimensions
                        canvas.height = this.naturalHeight;
                        canvas.width = this.naturalWidth;
                        // Draw the image to a canvas
                        ctx.drawImage(this, 0, 0);
                        // Convert the canvas to a data url
                        dataURL = canvas.toDataURL('image/jpeg');
                        // Return the data url via callback
                        let object = { data_url: dataURL, web_url: src };
                        resolve(object);
                        // Mark the canvas to be ready for garbage
                        // collection
                        canvas = null;
                    };
                    // Load the image
                    img.src = src;
                    // make sure the load event fires for cached images too
                    if (img.complete || img.complete === undefined) {
                        // Flush cache
                        img.src = 'data:image/jpeg;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
                        // Try again
                        img.src = src;
                    }
                } catch (e) {
                    reject(e)
                }
            });
        },
        dataURItoBlob: (dataURI) => {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = unescape(dataURI.split(',')[1]);
            }
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], { type: mimeString });
        },
        renderCustomIndustry: (instagram) => {

            if (instagram) {
                return flowRegister.getValue("ads_title_instagram");
            } else {
                return flowRegister.getValue("ads_title_facebook");
            }

            /*
            try {
                let scraper_data = JSON.parse(scraperRegister.get());
                let region = null;
                let cart = cartRegister.get();
                let display_region = JSON.parse(JSON.stringify(cart.display_region));
                if (scraper_data.region_grid) {
                    if(!display_region){
                        let lowest = 0;
                        for (let key in scraper_data.region_grid) {
                            if (scraper_data.region_grid[key].value !== "-1" && scraper_data.region_grid[key].value && scraper_data.region_grid[key].level < 4) {
                                if (+key > +lowest) {
                                    lowest = key;
                                }
                            }
                        }
                        region = JSON.parse(scraper_data.region_grid[lowest].value);
                    }else{
                        region = display_region;
                    }
                    if(scraper_data.additional_information.facts.address){
                        region.name = region.name + ', ' + scraper_data.additional_information.facts.address;
                        try {
                            if (region.name.length > 24) {
                                region.name = region.name.substr(0, 24);
                                region.name.trim();
                                region.name = region.name + "..";
                            }
                        } catch (e) {}
                    }
                }else{
                    region = {};
                }

                //SET PRICE AND CURRENCY
                let company_name = 0;
                let currency = null;

                company_name = scraper_data.additional_information.facts.price;
                currency = scraper_data.additional_information.facts.currency;

                if (+company_name > 0) {
                    company_name = currency + " " + this.parsers.number(company_name);
                } else {
                    company_name = "Price on request";
                }

                if (instagram) {
                    try {
                        if (scraper_data.additional_information.facts.listing_type.indentifier === "rent" && scraper_data.additional_information.facts.price > 0) {
                            return region.name + " | " + company_name + " " + scraper_data.additional_information.facts.duration.title;
                        } else {
                            return region.name + " | " + company_name;
                        }
                    } catch (e) {
                        return region.name + " | " + company_name;
                    }
                } else {
                    try {
                        if (scraper_data.additional_information.facts.listing_type.indentifier === "rent" && scraper_data.additional_information.facts.price > 0) {
                            return this.state.industry.name + " | " + region.name + " | " + company_name + " " + scraper_data.additional_information.facts.duration.title;
                        } else {
                            return this.state.industry.name + " | " + region.name + " | " + company_name;
                        }
                    } catch (e) {
                        return this.state.industry.name + " | " + region.name + " | " + company_name;
                    }

                }
            } catch (e) {
                console.log(e);
                return null;
            }
            */
        },
        checkCoupon: () => {
            if (!this.state.isCouponLoading && this.state.coupon !== "") {
                this.setState({ isCouponLoading: true }, () => {
                    dataRegister.checkCoupon(salesChannelRegister.get('market'), this.state.coupon).then((response) => {
                        if (response.discount_amount) {
                            if (this.state.service_fee_fixed) {
                                if (+response.discount_amount + 1 > this.calculate.exclVat() - this.calculate.fixedFee()) {
                                    this.setState({
                                        coupon_modal: true,
                                        isCouponLoading: false,
                                        coupon_success: false,
                                        discount: 0
                                    });
                                } else {
                                    this.setState({
                                        coupon_modal: false,
                                        isCouponLoading: false,
                                        coupon_success: true,
                                        discount: Math.round(+response.discount_amount)
                                    });
                                }
                            } else if (this.state.service_fee_percentage) {
                                if (+response.discount_amount + 1 > this.calculate.exclVat() - this.calculate.percentageFee()) {
                                    this.setState({
                                        coupon_modal: true,
                                        isCouponLoading: false,
                                        coupon_success: false,
                                        discount: 0
                                    });
                                } else {
                                    this.setState({
                                        coupon_modal: false,
                                        isCouponLoading: false,
                                        coupon_success: true,
                                        discount: Math.round(+response.discount_amount)
                                    });
                                }
                            } else {
                                if (+response.discount_amount + 1 > this.calculate.exclVat()) {
                                    this.setState({
                                        coupon_modal: true,
                                        isCouponLoading: false,
                                        coupon_success: false,
                                        discount: 0
                                    });
                                } else {
                                    this.setState({
                                        coupon_modal: false,
                                        isCouponLoading: false,
                                        coupon_success: true,
                                        discount: Math.round(+response.discount_amount)
                                    });
                                }
                            }
                        } else if (response.discount_percent) {
                            let amount = 0;
                            if (this.state.service_fee_fixed) {
                                amount = (this.calculate.fixedFee() / 100) * response.discount_percent;
                            } else if (this.state.service_fee_percentage) {
                                amount = (this.calculate.percentageFee() / 100) * response.discount_percent;
                            } else {
                                amount = (this.calculate.exclVat() / 100) * response.discount_percent;
                            }
                            this.setState({
                                coupon_modal: false,
                                isCouponLoading: false,
                                coupon_success: true,
                                discount: Math.round(+amount)
                            });
                        }

                        /*
                        //GOOGLE EVENT
                        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                            ReactGA.event({category: 'User', action: 'Added Coupon', value: this.state.discount});
                            ReactGA4.event({category: 'User', action: 'Added Coupon', value: this.state.discount});
                        }

                        //console.log("added coupon amount: " + this.state.discount + this.state.currency);

                        //FACEBOOK EVENT
                        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                            ReactPixel.trackCustom('AddCoupon', {value: this.state.discount, currency: this.state.currency});
                        }
                        */

                    }, (error) => {
                        this.setState({ coupon_modal: true, isCouponLoading: false, coupon_success: false, discount: 0 });
                    });
                })
            }
        },
        setCouponModal: (value) => {
            this.setState({ coupon_modal: value });
        }
    };

    _payment() {
        if (!this.state.isLoading) {
            //SET ALL VALIDATORS TO FALSE
            this.state.user_error = false;
            this.state.card_error.number = false;
            this.state.card_error.expiry = false;
            this.state.card_error.cvc = false;
            this.state.card_error.show = false;
            this.state.card_error.message = "";
            for (let key in this.state.form_validation) {
                this.state.form_validation[key] = false;
            }
            if (!this.state.logged_in) {
                this.state.form_validation.email = !this.validators.email(this.state.email);
                this.state.form_validation.password = this.state.password === "";
            }
            if (this.state.redirect) {
                this.state.form_validation.redirect_email = !this.validators.email(this.state.redirect_email);
            }
            if (this.state.landingpage) {

                this.state.form_validation.website = false;
                this.state.form_validation.landing_address = (this.state.landing_address === "");
                this.state.form_validation.landing_email = !this.validators.email(this.state.landing_email);

                //BROKER DATA
                if (!this.state.private_user) {
                    //this.state.form_validation.broker_brn = (this.state.broker_brn === "");
                    //this.state.form_validation.broker_ref = (this.state.broker_ref === "");
                    if (salesChannelRegister.get('name') !== "boostabostad") {
                    this.state.form_validation.broker_trakheesi = (this.state.broker_trakheesi === "");
                    }
                    this.state.form_validation.broker_company = (this.state.broker_company === "");
                }
                this.state.form_validation.broker_name = (this.state.broker_name === "");

            } else {
                if (this.state.own_url) {
                    this.state.form_validation.website = !this.validators.website(this.state.own_website);
                } else {
                    this.state.form_validation.website = !this.validators.website(this.state.website);
                }
            }
            this.state.form_validation.company_name = (this.state.company_name === "");

            this.state.form_validation.phone = !this.validators.phone(this.state.phone);

            try {
                this.state.form_validation.dialcode = !this.state.country.dialCode;
            } catch (e) {
                this.state.form_validation.dialcode = true;
            }

            this.setState({
                form_validation: this.state.form_validation,
                error: false,
                card_error: this.state.card_error,
                website_error: false,
                isLoading: true
            }, () => {
                //CHECK FOR VALIDATION ERRORS
                let result = false;
                for (let key in this.state.form_validation) {
                    if (this.state.form_validation[key]) {
                        result = true;
                        break;
                    }
                }
                //IF NO VALIDATION ERRORS
                if (!result) {
                    if (this._disablePhoneCheck()) {
                        //*OVERRIDE PHONE* Do not check phone if origin region is different from market
                        if (this.state.pay_now) {
                            this._charge()
                        } else {
                            this.functions.createCampaignNoPay();
                        }
                    } else {
                        //CHECK PHONE
                        this.setState({ isLoading: true }, () => {
                            /*
                            if (this.state.pay_now) {
                                this._charge();
                            } else {
                                this.functions.createCampaignNoPay();
                            }
                            */
                            //CHECK PHONE
                            let phone = "";
                            try {
                                phone = this.state.country.dialCode.replace('+', "");
                            } catch (e) {
                                console.log(e);
                            }
                            dataRegister.checkPhone(salesChannelRegister.get('market'), (phone + this.state.phone)).then((response) => {
                                if (response.countryCode && response.countryCode.toLowerCase() === salesChannelRegister.get('market').toLowerCase()) {
                                    if (this.state.own_url) {
                                        dataRegister.checkUrl({ url: this.state.own_website }).then((response) => {
                                            this.setState({
                                                website_error: false
                                            });
                                            if (this.state.pay_now) {
                                                this._charge();
                                            } else {
                                                this.functions.createCampaignNoPay();
                                            }
                                        }, (error) => {
                                            this.state.form_validation.website = true;
                                            this.setState({
                                                website_error: true,
                                                isLoading: false,
                                                form_validation: this.state.form_validation,
                                                error: true
                                            });
                                        });
                                    } else {
                                        if (this.state.pay_now) {
                                            this._charge();
                                        } else {
                                            this.functions.createCampaignNoPay();
                                        }
                                    }
                                } else {
                                    this.state.form_validation.phone = true;
                                    this.setState({
                                        isLoading: false,
                                        form_validation: this.state.form_validation,
                                        error: true
                                    });
                                }
                            }, (error) => {
                                this.state.form_validation.phone = true;
                                this.setState({
                                    isLoading: false,
                                    form_validation: this.state.form_validation,
                                    error: true
                                });
                            });
                        });
                    }
                } else {
                    //VALIDATION ERROR
                    this.setState({
                        error: true,
                        isLoading: false
                    });
                }
            });
        }
    }

    _charge() {

        let self = this;
        let Stripe = window.stripe_api;
        const paymentRequest = {
            currency: this.state.currency,
            amount: this.calculate.partialBudget() * 100
        };

        doPayment(paymentRequest);

        function doPayment(paymentRequest) {
            Stripe.createSource(window.cardNumber).then((cardResponse) => {
                if (!cardResponse.error) {
                    cardResponse = cardResponse.source;

                    if ((cardResponse.card.three_d_secure === 'not_supported' || cardResponse.card.three_d_secure === 'optional') && cardResponse.status === 'chargeable') {
                        self.setState({ payment_modal: false, isLoading: true }, () => {
                            createCampaign(cardResponse.id, false);
                        });
                    } else if (cardResponse.card.three_d_secure === 'required') {
                        Stripe.createSource({
                            type: 'three_d_secure',
                            amount: paymentRequest.amount,
                            currency: paymentRequest.currency,
                            three_d_secure: { card: cardResponse.id },
                            redirect: { return_url: "https://" + dataRegister.domain + "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/redirect" }
                        }).then((stripe3dsResponse) => {
                            if (!stripe3dsResponse.error) {
                                stripe3dsResponse = stripe3dsResponse.source;
                                self.setState({ payment_modal: true, isLoading: false }, () => {
                                    let height = window.innerWidth > 1050 ? 700 : 300;
                                    document.querySelector('#iframe-payment').innerHTML = '<iframe scrolling="true" style="width:100%; height:' + height + 'px" frameborder="0" src="' + stripe3dsResponse.redirect.url + '"></iframe>';
                                    pollForSourceStatus(stripe3dsResponse.id, stripe3dsResponse.client_secret, true);
                                });
                            } else {
                                self.setState({ isLoading: false }, () => {
                                    console.log(stripe3dsResponse);
                                });
                            }
                        })
                    }
                } else {
                    if (cardResponse.error.code === "invalid_number" || cardResponse.error.code === "incomplete_number") {
                        self.state.card_error.number = true;
                        self.state.card_error.show = true;
                        //self.state.card_error.message = cardResponse.error.message;
                    } else if (cardResponse.error.code === "invalid_expiry_year_past" || cardResponse.error.code === "invalid_expiry_month_past" || cardResponse.error.code === "incomplete_expiry") {
                        self.state.card_error.expiry = true;
                        self.state.card_error.show = true;
                        //self.state.card_error.message = cardResponse.error.message;
                    } else if (cardResponse.error.code === "incomplete_cvc" || cardResponse.error.code === "invalid_cvc") {
                        self.state.card_error.cvc = true;
                        self.state.card_error.show = true;
                        //self.state.card_error.message = cardResponse.error.message;
                    }
                    self.setState({ isLoading: false, card_error: self.state.card_error });
                }
            })
        }

        function pollForSourceStatus(SOURCE_ID, CLIENT_SECRET, three_d_secure) {
            Stripe.retrieveSource({ id: SOURCE_ID, client_secret: CLIENT_SECRET }).then(function (result) {
                var source = result.source;
                if (source.status === 'chargeable') {
                    self.setState({ payment_modal: false, isLoading: true }, () => {
                        createCampaign(source.id, three_d_secure);
                    });
                } else if (source.status === 'pending') {
                    setTimeout(pollForSourceStatus(SOURCE_ID, CLIENT_SECRET, three_d_secure), 1000);
                } else if (source.status === 'canceled' || source.status === 'consumed' || source.status === 'failed') {
                    this.setState({ isLoading: false });
                } else {
                    this.setState({ isLoading: false });
                }
            });
        }

        function createCampaign(id, three_d_secure) {
            //UPDATE CAMPAIGN DATA
            let campaign = self.update.campaign(id);
            const formData = new FormData();
            for (let key in campaign) {
                formData.append(key, campaign[key]);
            }
            //SET IF CARD IS A 3D SECURE CARD OR NOT
            if (three_d_secure) {
                formData.append("source_type", "three_d_secure_validated");
            } else {
                formData.append("source_type", "card");
            }
            //CHECK IF USER IS LOGGED IN
            if (self.state.logged_in) {
                //CREATE CAMPAIGN
                self.functions.createCampaignPay(formData);
            } else {
                //CREATE USER OBJECT
                let user = { email: self.state.email, password: self.state.password, lang: langRegister.lang() };
                //CALL API TO CREATE USER
                dataRegister.signUp(salesChannelRegister.get("market"), user).then((response) => {
                    if (!response.errors) {
                        //UPDATE USER DATA
                        userRegister.set(response);
                        self.update.user();
                        //PAY NOW
                        self.functions.createCampaignPay(formData);
                    } else {
                        //SIGNUP ERROR
                        self.setState({ isLoading: false }, () => {
                            console.log(response.errors)
                        });
                    }
                }, (error) => {
                    //CREATE USER SIGNUP API ERROR
                    if (error.status === 400) {
                        self.setState({ user_error: true, isLoading: false }, () => {
                            console.log(error);
                        });
                    } else {
                        self.setState({ system_error: true, isLoading: false }, () => {
                            console.log(error);
                        });
                    }
                });
            }
        }
    }

    _selectCountry(option) {
        this.setState({ country: option, search: option.dialCode });
    }

    _placement(place) {
        let cart = cartRegister.get();
        try {
            let channel = place === 'instagram';
            let query = {
                industry: !channel ? this.functions.renderCustomIndustry(channel) : this.state.industry.name,
                region: salesChannelRegister.get("market"),
                //website: !this.state.landingpage?this.state.website:'www.yourfreelandingpage.com',
                image: this.state.image.url,
                frame: this._placementFrame(place),
                saleschannel: salesChannelRegister.get("name"),
                pageTitle: salesChannelRegister.get('socialTitle'),
                pageImage: salesChannelRegister.get('socialIcon'),
                customCreative: collectedRegister.getValue("custom_creative") ? collectedRegister.getValue("custom_creative") : false
            };
            if (this.state.landingpage) {
                query.website = 'www.yourfreelandingpage.com';
            } else if (!this.validators.website(this.state.website) && this.state.own_url) {
                query.website = 'www.yoururl.com';
            } else if (this.validators.website(this.state.website) && this.state.own_url) {
                query.website = this.state.own_website;
            } else {
                query.website = this.state.website;
            }

            try {
                query.quotes = !channel ? this._renderQuotes(cart.quotes, channel) : ('| ' + this._renderQuotes(cart.quotes, channel));
            } catch (e) {
            }
            const stringified = queryString.stringify(query);
            let url = 'https://placement.' + dataRegister.domain;
            if (dataRegister.domain === "localhost") {
                url = 'https://placement.devpropertybooster.com';
            }
            var popUp = window.open(url + "/" + langRegister.lang() + "/" + place + "?" + stringified, '_blank');

        } catch (e) {
            console.log(e);
            window.open('https://placement.' + dataRegister.domain + "/" + langRegister.lang() + "/" + place, '_blank');
        }
    }

    _placementFrame(place) {
        let data = themeRegister.getValue();
        let theme = themeRegister.getTheme();
        let theme_data = themeRegister.getValue();
        let user_data = userRegister.getUser();
        let agent_data = agentRegister.get();

        let data_custom_creative = {};

        if (collectedRegister.getValue("custom_creative")) {

            if(theme_data && theme_data.theme_region){
                if (langRegister.lang() === "sv") {
                    data_custom_creative.agent_description = "Expert på " + theme_data.theme_region;
                } else {
                    data_custom_creative.agent_description = theme_data.theme_region + " Expert";
                }
            }

            let user_data = userRegister.getUser();
            let agent_data = agentRegister.get();
            if(user_data && user_data.branding_pref){
                data_custom_creative.branding_image = user_data.branding_image;
            }

            try {

                data_custom_creative.type = JSON.parse(collectedRegister.getValue("type")).title;
                //TODO: type_default only tested in EN and SE lang, other langs need to be tested
                data_custom_creative.type_default = JSON.parse(collectedRegister.getValue("type")).title + " " + collectedRegister.getValue("offering");
                data_custom_creative.offering = collectedRegister.getValue("offering");

                if (theme === "promotion") {
                    data_custom_creative.slogan = theme_data.slogan_offer;
                } else {
                    data_custom_creative.slogan = theme_data.slogan_validation;
                }

                if (collectedRegister.getValue("listing_type").indentifier === "sale") {
                    data_custom_creative.slogan_offering = JSON.parse(collectedRegister.getValue("status")).title;
                } else {
                    data_custom_creative.slogan_offering = JSON.parse(collectedRegister.getValue("furnishings")).title;
                }

                data_custom_creative.slogan_promo = theme_data.slogan_offer;
                data_custom_creative.slogan_calltoaction = theme_data.slogan_action;

                data_custom_creative.area = theme_data.theme_region;
                data_custom_creative.building = collectedRegister.getValue("google").autocomplete_address;
                data_custom_creative.city = collectedRegister.getValue("display_region").name;

                data_custom_creative.size = collectedRegister.getValue("size_custom");
                data_custom_creative.beds = JSON.parse(collectedRegister.getValue("bed")).title;
                data_custom_creative.baths = JSON.parse(collectedRegister.getValue("bath")).title;
                data_custom_creative.price = theme_data.last_title;

            } catch (e) {}

            try {
                if (collectedRegister.getValue("contact").permit) {
                    data_custom_creative.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                }
            } catch (e) {}

            try {
                if (collectedRegister.getValue("qrcode_ads")) {
                    data_custom_creative.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                }
            } catch (e) {}

            if(agent_data && agent_data.profile_image){
                if(agent_data && agent_data.profile_image){
                    data_custom_creative.agent_image = agent_data.profile_image;
                }
                if(agent_data && agent_data.name){
                    data_custom_creative.agent_name = agent_data.name;
                }
            }else{
                if(user_data && user_data.profile_image){
                    data_custom_creative.agent_image = user_data.profile_image;
                }
                if(user_data && user_data.logo_image){
                    data_custom_creative.agency_image = user_data.logo_image;
                }
                if(user_data && user_data.name){
                    data_custom_creative.agent_name = user_data.name;
                }
            }

        } else {

            if (theme_data && theme_data.theme_region) {
                if (langRegister.lang() === "sv") {
                    data.agent_description = "Expert på " + theme_data.theme_region;
                } else {
                    data.agent_description = theme_data.theme_region + " Expert";
                }
            }

            if (user_data && user_data.logo_image) {
                data.agency_image = user_data.logo_image;
            }
            if (!data.agent_description && user_data.company_name) {
                data.agent_description = user_data.company_name;
            }
            if (!data.agent_description && user_data.billing_company) {
                data.agent_description = user_data.billing_company;
            }

            if (agent_data && agent_data.profile_image) {
                if (agent_data && agent_data.profile_image) {
                    data.agent_image = agent_data.profile_image;
                }
                if (agent_data && agent_data.email) {
                    try {
                        let split_email = agent_data.email.split("@");
                        if (Array.isArray(split_email) && split_email.length > 1) {
                            data.agency_website = split_email[1];
                        }
                    } catch (e) { }
                }
                if (agent_data && agent_data.name) {
                    data.agent_name = agent_data.name;
                }

                if (user_data.fallback_pref && user_data.fallback_pref.phone) {
                    data.agent_phone = user_data.phone;
                } else {
                    if (agent_data && agent_data.phone) {
                        data.agent_phone = agent_data.phone;
                    }
                }

            } else {
                if (user_data && user_data.profile_image) {
                    data.agent_image = user_data.profile_image;
                }
                if (user_data && user_data.logo_image) {
                    data.agency_image = user_data.logo_image;
                }
                if (user_data && user_data.email) {
                    try {
                        let split_email = user_data.email.split("@");
                        if (Array.isArray(split_email) && split_email.length > 1) {
                            data.agency_website = split_email[1];
                        }
                    } catch (e) { }
                }
                if (user_data && user_data.name) {
                    data.agent_name = user_data.name;
                }
                if (user_data && user_data.phone) {
                    data.agent_phone = user_data.phone;
                }
            }

            if (user_data && user_data.branding_pref) {
                data.primary_color = user_data.branding_pref.primary_color;
                data.secondary_color = user_data.branding_pref.secondary_color;
                data.branding_image = user_data.branding_image;
            }

            try {
                if(user_data && user_data.branding_pref){
                    data.disable_infobox = user_data.branding_pref.disable_infobox ? user_data.branding_pref.disable_infobox : false;
                    data.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                    data.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                    data.opacity_infobox = user_data.branding_pref.opacity_infobox ? user_data.branding_pref.opacity_infobox : false;
                }
            } catch (e) {}

            try {
                if (collectedRegister.getValue("contact").permit) {
                    data.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                }
            } catch (e) {}

            try {
                if (collectedRegister.getValue("qrcode_ads")) {
                    data.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                }
            } catch (e) {}

        }

        let query = "";
        if (collectedRegister.getValue("custom_creative")) {
             query = queryString.stringify(data_custom_creative);
        } else  {
             query = queryString.stringify(data);
        }

        let images = imagesRegister.get();
        let cart = cartRegister.get();
        let slides = [];
        let main_image = null;
        let first_image = null;
        let second_image = null;
        let third_image = null;
        for (let i = 0; i < images.length; i++) {
            if (images[i].label && slides.length < 9) {
                let slide = {
                    small: images[i].images.small,
                    large: images[i].images.large
                };
                slides.push(slide);
            }
        }
        if (cart.admin_image) {
            main_image = cart.admin_image.images.large;
        }
        if (slides[0]) {
            first_image = slides[0].small;
        }
        if (slides[1]) {
            second_image = slides[1].small;
        }
        if (slides[2]) {
            third_image = slides[2].small;
        }

        let url = "";
        if (collectedRegister.getValue("custom_creative")) {
            url = "https://coral-app-xg6gr.ondigitalocean.app/";
            return url + collectedRegister.getValue("reseller_name") + "/canvas/" +
                theme + "/first/1_1?" +
                "main_image=" + main_image +
                "&one_image=" + first_image +
                "&two_image=" + second_image +
                "&three_image=" + third_image +
                "&" + query + "&legacy=false"
        } else {
            url = "https://preview." + dataRegister.domain + "/";
            return url + salesChannelRegister.get("name") + "/canvas/" +
                theme + "/first/" + place + "?" +
                "main_image=" + main_image +
                "&one_image=" + first_image +
                "&two_image=" + second_image +
                "&three_image=" + third_image +
                "&" + query
        }

    }

    _renderQuotes(quotes, instagram) {
        let quotes_string = "";
        if (!instagram) {
            if (quotes) {
                if (!quotes.custom) {
                    let i = 1;
                    var sortable = [];
                    for (var key in quotes) {
                        sortable.push([quotes[key], quotes[key].index]);
                    }
                    sortable.sort(function (a, b) {
                        return a[1] - b[1];
                    });
                    sortable.map((item) => {
                        quotes_string += item[0].slogan + (sortable.length > i ? " - " : "");
                        i++;
                    });
                } else {
                    quotes_string = quotes.text;
                }
                return quotes_string
            }
        } else {
            if (!quotes.custom) {
                let i = 1;
                var sortable = [];
                for (var key in quotes) {
                    sortable.push([quotes[key], quotes[key].index]);
                }
                sortable.sort(function (a, b) {
                    return a[1] - b[1];
                });
                sortable.map((item) => {
                    quotes_string += item[0].slogan + (sortable.length > i ? " - " : "");
                    i++;
                });

                if (this.functions.renderCustomIndustry(true)) {
                    quotes_string = this.functions.renderCustomIndustry(true) + " | " + quotes_string;
                }

            } else {
                quotes_string = this.state.quotes.text;
            }
            return quotes_string
        }
    }

    validators = {
        email: (value) => {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(value).toLowerCase());
        },
        website: (value) => {
            try {
                return value.length > 2
            } catch (e) {
                return false
            }
        },
        phone: (value) => {
            var re = /^[0-9 +]+$/;
            return re.test(String(value).toLowerCase()) && value.length > 5;
        }
    };

    calculate = {
        exclVat: () => {
            if (this.state.budget && this.state.channels) {
                let budget = 0;
                for (let key in this.state.budget) {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }
                // IF FIXED FEE
                if (this.state.service_fee_fixed) {
                    budget = budget + this.calculate.fixedFee();
                }
                //IF PERCENTAGE SERVICE FEE
                if (this.state.service_fee_percentage) {
                    budget = budget + this.calculate.percentageFee();
                }
                //IF COMMISSION
                if (!this.state.service_fee_percentage && !this.state.service_fee_fixed && this.state.lockin) {
                    budget = budget * this.state.lockin_plan.months;
                }
                return budget;
            }
        },
        partialBudget: () => {
            if (this.state.budget && this.state.channels) {
                let budget = 0;
                for (let key in this.state.budget) {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }
                // IF FIXED FEE
                if (this.state.service_fee_fixed) {
                    budget = budget + this.calculate.fixedFee();
                }
                //IF PERCENTAGE SERVICE FEE
                if (this.state.service_fee_percentage) {
                    budget = budget + this.calculate.percentageFee();
                }
                //IF COMMISSION
                if (!this.state.service_fee_percentage && !this.state.service_fee_fixed && this.state.lockin) {
                    budget = budget * this.state.lockin_plan.months;
                }
                //IF LOCKIN
                if (this.state.lockin) {
                    budget = budget - this.calculate.discount();
                }
                //IF DISCOUNT
                if (this.state.discount) {
                    budget = budget - this.state.discount;
                }
                //IF VAT
                if (this.state.vat) {
                    budget = budget + this.calculate.vat();
                }
                return budget;
            }
        },
        fixedFee: () => {
            if (this.state.lockin && this.state.lockin_plan) {
                return this.state.service_fee_fixed * this.state.lockin_plan.months;
            } else {
                return this.state.service_fee_fixed
            }
        },
        percentageFee: () => {
            if (this.state.budget && this.state.channels) {
                let budget = 0;
                for (let key in this.state.budget) {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }
                if (this.state.lockin && this.state.lockin_plan) {
                    return (budget * (this.state.service_fee_percentage / 100)) * this.state.lockin_plan.months;
                } else {
                    return budget * (this.state.service_fee_percentage / 100);
                }
            }
        },
        discount: () => {
            if (this.state.lockin_plan) {
                let budget = 0;
                for (let key in this.state.budget) {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }
                if (this.state.service_fee_fixed) {
                    return this.state.service_fee_fixed * this.state.lockin_plan.free_months;
                } else if (this.state.service_fee_percentage) {
                    return (budget * (this.state.service_fee_percentage / 100)) * this.state.lockin_plan.free_months;
                } else {
                    return budget * this.state.lockin_plan.free_months;
                }
            }
        },
        vat: () => {
            if (this.state.budget && this.state.channels) {
                let budget = 0;
                for (let key in this.state.budget) {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }
                // IF FIXED FEE
                if (this.state.service_fee_fixed) {
                    budget = budget + this.calculate.fixedFee();
                }
                //IF PERCENTAGE SERVICE FEE
                if (this.state.service_fee_percentage) {
                    budget = budget + this.calculate.percentageFee();
                }
                //IF COMMISSION
                if (!this.state.service_fee_percentage && !this.state.service_fee_fixed && this.state.lockin) {
                    budget = budget * this.state.lockin_plan.months;
                }
                //IF LOCKIN
                if (this.state.lockin) {
                    budget = budget - this.calculate.discount();
                }
                return budget * (this.state.vat / 100);
            }
        },
        estimatedConversions: (cost) => {
            if (this.state.budget && this.state.channels) {
                let budget = 0;
                let result_low = 0;
                let result_high = 0;
                let market_factor = 0;
                for (let key in this.state.budget) {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }

                if (salesChannelRegister.get('market').toLowerCase() === "se") {
                    market_factor = 1;
                } else {
                    market_factor = 0.5;
                }

                result_low = Math.round((budget / cost) * 0.75 * market_factor);
                result_high = Math.round((budget / cost) * 1.25 * market_factor);
                return result_low + " - " + result_high;
            }
        }
    };

    renders = {
        modal: () => {
            if (this.state.payment_modal) {
                return (
                    <div className={Styles.paymentModalContainer}>
                        <div className={Styles.paymentModalContainerInner}>
                            <div onClick={() => this.setState({ payment_modal: false })}
                                className={Styles.paymentModalContainerInnerClose}>
                                <img className={Styles.paymentModalContainerInnerCloseIcon}
                                    src={require("../../assets/images/close_icon.svg")} />
                            </div>
                            <div className={Styles.paymentModalContainerInnerFrame}>
                                <div id="iframe-payment" />
                            </div>
                            <BeatLoader size={30} color={'var(--first-color)'} loading={true} />
                        </div>
                    </div>
                )
            }
        },
        previewLandingPage: () => {
            return (
                <div className={Styles.inputDivider}>
                    <div className={Styles.inputDividerItem}>
                        <div onClick={() => this.functions.reviewLanding()}
                            className={cx(Styles.button, Styles.buttonBlack)}>
                            {this.parsers.text("item_43")}
                        </div>
                    </div>
                </div>
            )
        },
        showWebsite: () => {
            try {
                let scraper_data = JSON.parse(scraperRegister.get());
                console.log(scraper_data);
                if (scraper_data.additional_information.url) {
                    return false
                } else {
                    return true;
                }
            } catch (e) {
                return true;
            }
        },
        previewAds: (channel) => {
            let cart = cartRegister.get();
            try {
                let exist = false;
                for (let key in cart.channels) {
                    if (channel === key && cart.channels[key].selected) {
                        exist = true;
                        break;
                    }
                }
                return exist
            } catch (e) {

            }
        },
        autocomplete: (value) => {
            try {
                if (!this.state.autocomplete_search) {
                    return value
                }
                return value.replace(new RegExp(this.state.autocomplete_search, "gi"), match => {
                    return '<bold>' + match + '</bold>';
                });
            } catch (e) {
                return value
            }
        }
    };

    parsers = {
        number: (value) => {
            try {
                value = Math.round(value * 100) / 100;
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } catch (e) {
                return (0)
            }
        },
        text: (value) => {
            return langRegister.get("signup-payment", value);
        }
    };

    //*OVERRIDE PHONE* Check if origin region is different from market
    _disablePhoneCheck() {

        let region = collectedRegister.getValue("region");

        console.log(region.country_code.toLowerCase());
        console.log(salesChannelRegister.get("market").toLowerCase());

        if (region.country_code.toLowerCase() !== salesChannelRegister.get("market").toLowerCase()) {
            return true;
        } else {
            return false;
        }

    };

    render() {
        return (
            <div>
                {
                    this.state.coupon_modal &&
                    <ModalCoupon setModal={this.functions.setCouponModal} />
                }
                {
                    this.renders.modal()
                }
                <BoosterHeaderSecond history={this.props.history} props={this.props} step={5} />
                {
                    this.state.channels && this.state.budget && this.state.currency && !this.state.system_error &&
                    <div className={Styles.container}>
                        <div style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                            className={Styles.title}>
                            <span
                                className={Styles.bold}>{this.parsers.text("item_3")}</span>{this.parsers.text("item_4")}
                        </div>
                        {
                            !this.state.register && !this.state.logged_in &&
                            <div className={Styles.subtitle}>
                                {this.parsers.text("item_1")}<span
                                    className={cx(Styles.bold, Styles.link)}
                                    onClick={() => {
                                        try {
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login" + "?from_path=" + this.props.location.pathname);
                                        } catch (e) {
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
                                        }
                                    }
                                    }>{this.parsers.text("item_2")}</span>
                            </div>
                        }
                        {
                            this.state.register && !this.state.logged_in &&
                            <div className={Styles.subtitle}>
                                {this.parsers.text("item_23")}<span
                                    className={cx(Styles.bold)}>{this.parsers.text("item_24")}</span>
                            </div>
                        }

                        {
                            !this.state.register && !this.state.logged_in &&
                            <div>
                                <div className={Styles.itemHeader}>
                                    {this.parsers.text("item_5")}
                                </div>

                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            type="email"
                                            value={this.state.email}
                                            onChange={(event) => this.setState({ email: event.target.value.toLowerCase() })}
                                            className={Styles.input}
                                            placeholder={this.parsers.text("item_8")}
                                        />
                                        {
                                            ((this.state.form_validation.email && !this.validators.email(this.state.email)) || this.state.user_error) &&
                                            <div
                                                style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                className={Styles.inputError} />
                                        }
                                    </div>
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            value={this.state.password}
                                            onChange={(event) => this.setState({ password: event.target.value })}
                                            className={Styles.input}
                                            type={"password"}
                                            placeholder={this.parsers.text("item_9")}
                                        />
                                        {
                                            ((this.state.form_validation.password && this.state.password === "") || this.state.user_error) &&
                                            <div
                                                style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                className={Styles.inputError} />
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            salesChannelRegister.get("name") !== "yieldlock" &&
                            <div className={cx(Styles.itemHeader, Styles.itemHeaderTop)}>
                                <div className={Styles.itemHeaderText}>
                                    {this.parsers.text("item_10")}
                                </div>
                            </div>
                        }
                        {
                            salesChannelRegister.get("name") !== "yieldlock" &&
                            <div className={Styles.inputDivider}>
                                <div>
                                    <div
                                        className={cx(Styles.radioButtonContainer, Styles.radioButtonContainerFirst, Styles.radioButtonContainerMultiple)}>
                                        {
                                            this.state.portal_exist &&
                                            <div style={this.state.inhouse ? {} : { cursor: 'not-allowed' }} onClick={() => {
                                                if (this.state.inhouse) {
                                                this.setState({
                                                    portal_url: true,
                                                    pay_now: true,
                                                    own_url: false,
                                                    landingpage: false,
                                                    website_error: false
                                                });
                                                }
                                            }} className={cx(Styles.radioButton,
                                                {
                                                    [Styles.radioButtonContainerDisabled]: !this.state.inhouse
                                                })}>
                                                <div className={
                                                    cx(Styles.radioButtonCircle,
                                                        {
                                                            [Styles.radioButtonCircleActive]: this.state.portal_url,
                                                        })
                                                }>
                                                    {
                                                        this.state.portal_url &&
                                                        <div className={Styles.radioButtonCircleActiveCirlce} />
                                                    }
                                                </div>
                                                {
                                                    this.state.portal_exist && !this.state.website_url &&
                                                    <div
                                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                        className={cx(Styles.radioButtonTitle, Styles.radioButtonTitleExtraSpace)}>
                                                        {this.parsers.text("item_91")}
                                                    </div>
                                                }
                                                {
                                                    this.state.portal_exist && this.state.website_url &&
                                                    <div
                                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                        className={cx(Styles.radioButtonTitle, Styles.radioButtonTitleExtraSpace)}>
                                                        {this.parsers.text("item_92")}
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {
                                            <div style={this.state.inhouse ? {} : { cursor: 'not-allowed' }} onClick={() => {
                                                if (this.state.inhouse) {
                                                this.setState({
                                                    own_url: true,
                                                    pay_now: true,
                                                    landingpage: false,
                                                    portal_url: false
                                                });
                                                }
                                            }} className={cx(Styles.radioButton,
                                                {
                                                    [Styles.radioButtonContainerDisabled]: !this.state.inhouse
                                                })}>
                                                <div className={
                                                    cx(Styles.radioButtonCircle,
                                                        {
                                                            [Styles.radioButtonCircleActive]: this.state.own_url,
                                                        })
                                                }>
                                                    {
                                                        this.state.own_url &&
                                                        <div className={Styles.radioButtonCircleActiveCirlce} />
                                                    }
                                                </div>
                                                <div
                                                    style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                    className={cx(Styles.radioButtonTitle, Styles.radioButtonTitleExtraSpace)}>
                                                    {this.parsers.text("item_95")}
                                                </div>
                                            </div>
                                        }
                                        {
                                            <div onClick={() => {
                                                this.setState({
                                                    landingpage: true,
                                                    own_url: false,
                                                    portal_url: false
                                                });
                                            }} className={Styles.radioButton}>
                                                <div className={
                                                    cx(Styles.radioButtonCircle,
                                                        {
                                                            [Styles.radioButtonCircleActive]: this.state.landingpage,
                                                        })
                                                }>
                                                    {
                                                        this.state.landingpage &&
                                                        <div className={Styles.radioButtonCircleActiveCirlce} />
                                                    }
                                                </div>
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? { color: '#00273A' } : {}}
                                                    className={cx(Styles.radioButtonTitle, Styles.radioButtonTitleExtraSpace)}>
                                                    {this.parsers.text("item_83")}
                                                </div>
                                                {
                                                    <div
                                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { backgroundColor: '#E65032' } : {}}
                                                        className={Styles.optionsContainerItemInnerBadge}>
                                                        {this.parsers.text("item_101")}
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            ((this.renders.showWebsite() && !this.state.landingpage) && !this.state.own_url) && salesChannelRegister.get("name") !== "yieldlock" &&
                            <div className={Styles.inputDivider}>
                                <div style={{ width: "100%", flexBasis: "100%" }} className={Styles.inputDividerItem}>
                                    <input
                                        value={this.state.website}
                                        onChange={(event) => this.setState({ website: event.target.value })}
                                        /*style={salesChannelRegister.get('name')==='yieldlock'?{color: '#80929C'}:{}}/*/
                                        className={cx(Styles.input,
                                            {
                                                [Styles.inputDisabled]: this.state.landingpage
                                            })}
                                        disabled={this.state.landingpage || this.state.portal_url}
                                        placeholder={this.parsers.text("item_84")}
                                    />
                                    {
                                        ((this.state.form_validation.website && !this.state.landingpage && !this.validators.website(this.state.website)) || this.state.website_error) &&
                                        <div
                                            style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                            className={Styles.inputError}></div>
                                    }
                                </div>
                            </div>
                        }
                        {
                            this.state.own_url && salesChannelRegister.get("name") !== "yieldlock" &&
                            <div className={Styles.inputDivider}>
                                <div style={{ width: '100%', flexBasis: '100%' }} className={Styles.inputDividerItem}>
                                    <input
                                        value={this.state.own_website}
                                        onChange={(event) => this.setState({ own_website: event.target.value })}
                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A', width: '100%' } : { width: '100%' }}
                                        className={cx(Styles.input,
                                            {
                                                [Styles.inputDisabled]: !this.state.own_url
                                            })}
                                        disabled={!this.state.own_url}
                                        placeholder={this.parsers.text("item_84")}
                                    />
                                    {
                                        ((this.state.form_validation.website && !this.state.landingpage && this.state.own_url && !this.validators.website(this.state.own_website)) || this.state.website_error) &&
                                        <div
                                            style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                            className={Styles.inputError}></div>
                                    }
                                </div>
                            </div>
                        }
                        {
                            this.state.landingpage && false &&
                            <div className={Styles.itemHeader}>
                                <div className={Styles.itemHeaderText}>
                                    {this.parsers.text("item_77")}
                                </div>
                            </div>
                        }
                        {
                            this.state.landingpage && false &&
                            <div className={Styles.inputDivider}>
                                <div>
                                    <div className={cx(Styles.radioButtonContainer, Styles.radioButtonContainerFirst)}>
                                        <div onClick={() => {
                                            this.setState({ private_user: false, });
                                        }} className={Styles.radioButton}>
                                            <div className={
                                                cx(Styles.radioButtonCircle,
                                                    {
                                                        [Styles.radioButtonCircleActive]: !this.state.private_user,
                                                    })
                                            }>
                                                {
                                                    !this.state.private_user &&
                                                    <div className={Styles.radioButtonCircleActiveCirlce} />
                                                }
                                            </div>
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={cx(Styles.radioButtonTitle, Styles.radioButtonTitleExtraSpace)}>
                                                {this.parsers.text("item_73")}
                                            </div>
                                        </div>
                                        <div onClick={() => {
                                            this.setState({ private_user: true });
                                        }} className={Styles.radioButton}>
                                            <div className={
                                                cx(Styles.radioButtonCircle,
                                                    {
                                                        [Styles.radioButtonCircleActive]: this.state.private_user,
                                                    })
                                            }>
                                                {
                                                    this.state.private_user &&
                                                    <div className={Styles.radioButtonCircleActiveCirlce} />
                                                }
                                            </div>
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={cx(Styles.radioButtonTitle, Styles.radioButtonTitleExtraSpace)}>
                                                {this.parsers.text("item_74")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            this.state.landingpage && false &&
                            <div className={Styles.itemHeader}>
                                <div className={Styles.itemHeaderText}>
                                    {this.parsers.text("item_78")}
                                </div>
                            </div>
                        }
                        {
                            this.state.landingpage && false &&
                            <div className={Styles.itemHeader}>
                                <div className={Styles.itemHeaderText}>
                                    {this.parsers.text("item_79")}
                                </div>
                            </div>
                        }
                        {
                            this.state.landingpage && false &&
                            <div className={Styles.inputDivider}>
                                <div className={Styles.inputDividerItem}>
                                    <input
                                        type={'text'}
                                        autoComplete={false}
                                        onFocus={() => {
                                            this.setState({ autocomplete_dropdown: true })
                                        }}
                                        onBlur={() => {
                                            this.setState({ autocomplete_dropdown: false })
                                        }}
                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                        className={Styles.input}
                                        value={this.state.autocomplete_search}
                                        placeholder={this.parsers.text("item_85")}
                                        onChange={(event) => {
                                            try {
                                                this.setState({ autocomplete_search: event.target.value }, () => {
                                                    if (this.state.autocomplete_search !== this.state.landing_address) {
                                                        this.setState({ lng: null, lat: null, landing_address: null });
                                                    }
                                                    if (this.state.autocomplete_search && this.state.autocomplete_search !== "") {
                                                        let scraper_data = JSON.parse(scraperRegister.get());
                                                        let region = null;
                                                        try {
                                                            region = JSON.parse(scraper_data.region_grid[1].value).country_code;
                                                        } catch (e) {
                                                            region = null;
                                                        }
                                                        this.setState({ autocomplete_dropdown: true }, () => {
                                                            let auto_this = this;
                                                            this.autocomplete.getPlacePredictions({
                                                                input: this.state.autocomplete_search,
                                                                componentRestrictions: { country: region ? region : '' }
                                                            }, function (predictions, status) {
                                                                if (status === 'OK' && predictions && predictions.length > 0) {
                                                                    console.log(predictions);
                                                                    auto_this.setState({ autocomplete_predictions: predictions });
                                                                } else {
                                                                    auto_this.setState({
                                                                        autocomplete_dropdown: false,
                                                                        autocomplete_predictions: []
                                                                    })
                                                                }
                                                            });
                                                        })
                                                    } else {
                                                        this.setState({
                                                            autocomplete_dropdown: false,
                                                            autocomplete_predictions: []
                                                        })
                                                    }
                                                })
                                            } catch (e) {
                                            }
                                        }}
                                    />
                                    {
                                        this.state.autocomplete_dropdown && this.state.autocomplete_predictions.length > 0 &&
                                        <div className={Styles.inputDividerItemDropdown}>
                                            {
                                                this.state.autocomplete_predictions.map((item) => {
                                                    return (
                                                        <div onMouseDown={() => {
                                                            let google_this = this;
                                                            try {
                                                                this.geocoder.geocode({ 'placeId': item.place_id }, function (results, status) {
                                                                    console.log(results);
                                                                    if (status === 'OK' && results && results.length > 0) {
                                                                        try {
                                                                            google_this.setState({
                                                                                lat: results[0].geometry.location.lat(),
                                                                                lng: results[0].geometry.location.lng(),
                                                                                autocomplete_search: item.description,
                                                                                landing_address: item.description
                                                                            });
                                                                        } catch (e) {

                                                                        }
                                                                    } else {

                                                                    }
                                                                });
                                                            } catch (e) {
                                                            }

                                                        }} className={Styles.inputDividerItemDropdownItem}>
                                                            <div
                                                                dangerouslySetInnerHTML={{ __html: this.renders.autocomplete(item.description) }}
                                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                                className={Styles.inputDividerItemDropdownItemText}></div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                    {
                                        this.state.form_validation.landing_address && this.state.landingpage &&
                                        <div
                                            style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                            className={Styles.inputError} />
                                    }
                                </div>
                            </div>
                        }

                        <div className={Styles.itemHeader}>
                            <div className={Styles.itemHeaderText}>
                                {
                                    this.state.landingpage && !this.state.private_user &&
                                    <span>{this.parsers.text("item_80")}</span>
                                }
                                {
                                    this.state.landingpage && this.state.private_user &&
                                    <span>{this.parsers.text("item_81")}</span>
                                }
                                {
                                    !this.state.landingpage &&
                                    <span>{this.parsers.text("item_82")}</span>
                                }
                            </div>
                        </div>
                        <div className={Styles.brokerInformation}>
                            {
                                this.state.landingpage &&
                                <div className={cx(Styles.brokerInformationImage, Styles.brokerInformationImageMobile)}>
                                    <div style={{ backgroundImage: "url(" + this.state.broker_image + ")" }} className={Styles.brokerInformationImageItem}>
                                        {
                                            this.state.broker_image && this.state.inhouse &&
                                            <div className={Styles.brokerInformationImageItemPlus}>
                                                <input
                                                    onChange={(e) => this.functions.changeProfileImage(e)}
                                                    type="file"
                                                    accept="image/jpeg, image/png"
                                                    className={Styles.brokerInformationImageItemPlusUpload} />
                                                <img
                                                    className={Styles.brokerInformationImageItemPlusIcon}
                                                    src={require("../../assets/images/plus_sign_white_small.png")} />
                                            </div>
                                        }
                                        {
                                            !this.state.broker_image && this.state.inhouse &&
                                            <div
                                                className={Styles.brokerInformationImageItemLargePlus}>
                                                <input
                                                    onChange={(e) => this.functions.changeProfileImage(e)}
                                                    type="file" accept="image/jpeg, image/png"
                                                    className={Styles.brokerInformationImageItemPlusUpload} />
                                                +
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage && (salesChannelRegister.get('name') === "propertybooster" || salesChannelRegister.get('name') === "yieldlock") &&
                                <div className={cx(Styles.brokerInformationQrCode, Styles.brokerInformationQrCodeMobile)}>
                                    <div style={{ backgroundImage: "url(" + this.state.broker_qrcode + ")" }} className={Styles.brokerInformationQrCodeItem}>
                                        {
                                            this.state.broker_qrcode &&
                                            <div className={Styles.brokerInformationQrCodeItemPlus}>
                                                <input
                                                    onChange={(e) => this.functions.changeQrCodeImage(e)}
                                                    type="file"
                                                    accept="image/jpeg, image/png"
                                                    className={Styles.brokerInformationImageItemPlusUpload} />
                                                <img
                                                    className={Styles.brokerInformationImageItemPlusIcon}
                                                    src={require("../../assets/images/plus_sign_white_small.png")} />
                                            </div>
                                        }
                                        {
                                            !this.state.broker_qrcode &&
                                            <div
                                                className={Styles.brokerInformationQrCodeItemLargePlus}>
                                                <input
                                                    onChange={(e) => this.functions.changeQrCodeImage(e)}
                                                    type="file" accept="image/jpeg, image/png"
                                                    className={Styles.brokerInformationImageItemPlusUpload} />
                                                +
                                            </div>
                                        }
                                        {
                                            <div className={Styles.brokerInformationQrCodeItemText}>
                                                {this.parsers.text("item_125")}
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            onKeyPress={(event) => {
                                                if (event.which === 13 /* Enter */) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            value={this.state.broker_name}
                                            onChange={(event) => this.setState({ broker_name: event.target.value })}
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                            className={Styles.input}
                                            type={"text"}
                                            placeholder={this.parsers.text("item_86")}
                                        />
                                        {
                                            this.state.form_validation.broker_name && this.state.broker_name === "" &&
                                            <div
                                                style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                className={Styles.inputError} />
                                        }
                                    </div>
                                </div>
                            }

                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            onKeyPress={(event) => {
                                                if (event.which === 13 /* Enter */) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            value={this.state.landing_email}
                                            onChange={(event) => this.setState({ landing_email: event.target.value.toLowerCase() })}
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                            className={Styles.input}
                                            type={"email"}
                                            placeholder={this.parsers.text("item_87")}
                                        />
                                        {
                                            this.state.form_validation.landing_email && !this.validators.email(this.state.landing_email) && this.state.landingpage &&
                                            <div
                                                style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                className={Styles.inputError} />
                                        }
                                    </div>
                                </div>
                            }

                            {
                                this.state.landingpage && !this.state.private_user &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            value={this.state.broker_company}
                                            onChange={(event) => {
                                                try {
                                                    this.setState({ broker_company: event.target.value })
                                                } catch (e) {
                                                }
                                            }}
                                            onKeyPress={(event) => {
                                                if (event.which === 13 /* Enter */) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                            className={Styles.input}
                                            type={"email"}
                                            placeholder={this.parsers.text("item_88")}
                                        />
                                        {
                                            this.state.form_validation.broker_company && this.state.broker_company === "" &&
                                            <div
                                                style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                className={Styles.inputError} />
                                        }
                                    </div>
                                </div>
                            }

                            {
                                this.state.landingpage && !this.state.private_user && false &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            onKeyPress={(event) => {
                                                if (event.which === 13 /* Enter */) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            value={this.state.broker_brn}
                                            onChange={(event) => this.setState({ broker_brn: event.target.value })}
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                            className={Styles.input}
                                            type={"text"}
                                            placeholder={this.parsers.text("item_89")}
                                        />
                                        {
                                            this.state.form_validation.broker_brn && this.state.broker_brn === "" &&
                                            <div
                                                style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                className={Styles.inputError} />
                                        }
                                    </div>
                                </div>
                            }

                            {
                                this.state.landingpage && !this.state.private_user &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            onKeyPress={(event) => {
                                                if (event.which === 13 /* Enter */) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            value={this.state.broker_ref}
                                            onChange={(event) => this.setState({ broker_ref: event.target.value })}
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                            className={Styles.input}
                                            type={"text"}
                                            placeholder={this.parsers.text("item_102")}
                                        />
                                        {
                                            this.state.form_validation.broker_ref && this.state.broker_ref === "" &&
                                            <div
                                                style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                className={Styles.inputError} />
                                        }
                                    </div>
                                </div>
                            }

                            {
                                this.state.landingpage && !this.state.private_user &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            onKeyPress={(event) => {
                                                if (event.which === 13 /* Enter */) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            value={this.state.broker_trakheesi}
                                            onChange={(event) => this.setState({ broker_trakheesi: event.target.value })}
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                            className={Styles.input}
                                            type={"text"}
                                            placeholder={this.parsers.text("item_90")}
                                        />
                                        {
                                            this.state.form_validation.broker_trakheesi && this.state.broker_trakheesi === "" &&
                                            <div
                                                style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                className={Styles.inputError} />
                                        }
                                    </div>
                                </div>
                            }
                            {
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemInner}>
                                            <div className={Styles.inputDividerItemInnerDropdown}>
                                                <input
                                                    onKeyPress={(event) => {
                                                        if (event.which === 13 /* Enter */) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    placeholder={this.parsers.text("item_55")}
                                                    type="tel"
                                                    onFocus={() => this.setState({ dropdown: true })}
                                                    onBlur={() => this.setState({ dropdown: false })}
                                                    value={this.state.search}
                                                    onChange={(event) => this.setState({ search: event.target.value }, () => {
                                                        if (this.state.search !== this.state.country.dialCode) {
                                                            console.log(this.state.country.dialCode);
                                                            this.setState({ country: {} });
                                                        }
                                                    })}
                                                    style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                    className={Styles.inputDividerItemInnerDropdownInput}
                                                />
                                                {
                                                    this.state.dropdown && this.state.countries.filter((item) => {
                                                        return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                    }).length > 0 &&
                                                    <div className={Styles.dropdownList}>
                                                        {
                                                            this.state.countries.filter((item) => {
                                                                return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                            }).map((prop, key) => {
                                                                return (
                                                                    <div key={key}
                                                                        onMouseDown={() => this._selectCountry(prop)}
                                                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                                        className={Styles.dropdownListItem}>
                                                                        {prop.dialCode}
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                }
                                                {
                                                    this.state.form_validation.dialcode && !this.state.country.dialCode &&
                                                    <div
                                                        style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                        className={Styles.inputError} />
                                                }
                                            </div>
                                            <div className={Styles.inputDividerItemInnerInput}>
                                                <InputMask
                                                    style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                    className={cx(Styles.input)}
                                                    onKeyPress={(event) => {
                                                        if (event.which === 13 /* Enter */) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    type="tel"
                                                    placeholder={this.parsers.text("item_21")}
                                                    maskChar={null}
                                                    mask={"9999999999999999"}
                                                    value={this.state.phone}
                                                    onChange={(event) => this.setState({ phone: event.target.value.trim() })} />
                                                {
                                                    this.state.form_validation.phone && this.state.error &&
                                                    <div
                                                        style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                        className={Styles.inputError} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        this.state.landingpage &&
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.checkMarksContainerItem}>
                                                {
                                                    !this.state.whatsapp &&
                                                    <img
                                                        onClick={() => this.setState({ whatsapp: true })}
                                                        src={require("../../assets/images/square_checkmark_two.svg")}
                                                        className={Styles.checkMarksContainerItemIcon} />
                                                }
                                                {
                                                    salesChannelRegister.get('name') === "propertybooster" &&
                                                    this.state.whatsapp &&
                                                    <img
                                                        onClick={() => this.setState({ whatsapp: false })}
                                                        src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                        className={Styles.checkMarksContainerItemIcon} />
                                                }
                                                {
                                                    salesChannelRegister.get('name') === "boostabostad" &&
                                                    this.state.whatsapp &&
                                                    <img
                                                        onClick={() => this.setState({ whatsapp: false })}
                                                        src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                        className={Styles.checkMarksContainerItemIcon} />
                                                }
                                                {
                                                    salesChannelRegister.get('name') === "yieldlock" &&
                                                    this.state.whatsapp &&
                                                    <img
                                                        onClick={() => this.setState({ whatsapp: false })}
                                                        src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                        className={Styles.checkMarksContainerItemIcon} />
                                                }
                                                {
                                                    salesChannelRegister.get('name') !== "yieldlock" &&
                                                    <img
                                                        onClick={() => this.setState({ whatsapp: false })}
                                                        src={require("../../assets/images/whatsapp.png")}
                                                        className={Styles.checkMarksContainerItemWhatsapp} />
                                                }
                                                {
                                                    salesChannelRegister.get('name') === "yieldlock" &&
                                                    <img
                                                        onClick={() => this.setState({ whatsapp: false })}
                                                        src={require("../../assets/images/whatsapp_yl.png")}
                                                        className={Styles.checkMarksContainerItemWhatsapp} />
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            {
                                this.state.landingpage && !this.state.branding &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                <img style={{ cursor: 'default' }}
                                                    src={require("../../assets/images/checkmark-disabled.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                style={{ paddingRight: 'calc(var(--size-factor) * 20px)' }}
                                                className={Styles.checkMarksContainerItemText}>
                                                {this.state.branding ? this.parsers.text("item_108") : this.parsers.text("item_109")}
                                            </div>
                                            {
                                                <div
                                                    style={salesChannelRegister.get('name') === 'yieldlock' ? { backgroundColor: '#E65032' } : {}}
                                                    className={Styles.optionsContainerItemInnerBadge}>
                                                    {this.parsers.text("item_110")}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.plugin_leadform_callback &&
                                                <img onClick={() => this.setState({ plugin_leadform_callback: true, plugin_leadform_earlyaccess: false, plugin_leadform_viewing: false, plugin_leadform_moreinfo: false })}
                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_callback && salesChannelRegister.get('name') === "propertybooster" &&
                                                <img onClick={() => this.setState({ plugin_leadform_callback: false, plugin_leadform_earlyaccess: false, plugin_leadform_viewing: false, plugin_leadform_moreinfo: false })}
                                                    src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_callback && salesChannelRegister.get('name') === "boostabostad" &&
                                                <img onClick={() => this.setState({ plugin_leadform_callback: false, plugin_leadform_earlyaccess: false, plugin_leadform_viewing: false, plugin_leadform_moreinfo: false })}
                                                    src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_callback && salesChannelRegister.get('name') === "yieldlock" &&
                                                <img onClick={() => this.setState({ plugin_leadform_callback: false, plugin_leadform_earlyaccess: false, plugin_leadform_viewing: false, plugin_leadform_moreinfo: false })}
                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={Styles.checkMarksContainerItemText}>
                                                {this.parsers.text("item_105")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.plugin_leadform_moreinfo &&
                                                <img onClick={() => this.setState({ plugin_leadform_moreinfo: true, plugin_leadform_earlyaccess: false, plugin_leadform_viewing: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_moreinfo && salesChannelRegister.get('name') === "propertybooster" &&
                                                <img onClick={() => this.setState({ plugin_leadform_moreinfo: false, plugin_leadform_earlyaccess: false, plugin_leadform_viewing: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_moreinfo && salesChannelRegister.get('name') === "boostabostad" &&
                                                <img onClick={() => this.setState({ plugin_leadform_moreinfo: false, plugin_leadform_earlyaccess: false, plugin_leadform_viewing: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_moreinfo && salesChannelRegister.get('name') === "yieldlock" &&
                                                <img onClick={() => this.setState({ plugin_leadform_moreinfo: false, plugin_leadform_earlyaccess: false, plugin_leadform_viewing: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={Styles.checkMarksContainerItemText}>
                                                {this.parsers.text("item_98")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.plugin_leadform_viewing &&
                                                <img onClick={() => this.setState({ plugin_leadform_viewing: true, plugin_leadform_earlyaccess: false, plugin_leadform_moreinfo: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_viewing && salesChannelRegister.get('name') === "propertybooster" &&
                                                <img onClick={() => this.setState({ plugin_leadform_viewing: false, plugin_leadform_earlyaccess: false, plugin_leadform_moreinfo: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_viewing && salesChannelRegister.get('name') === "boostabostad" &&
                                                <img onClick={() => this.setState({ plugin_leadform_viewing: false, plugin_leadform_earlyaccess: false, plugin_leadform_moreinfo: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_viewing && salesChannelRegister.get('name') === "yieldlock" &&
                                                <img onClick={() => this.setState({ plugin_leadform_viewing: false, plugin_leadform_earlyaccess: false, plugin_leadform_moreinfo: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={Styles.checkMarksContainerItemText}>
                                                {this.parsers.text("item_100")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.plugin_leadform_earlyaccess &&
                                                <img onClick={() => this.setState({ plugin_leadform_earlyaccess: true, plugin_leadform_moreinfo: false, plugin_leadform_viewing: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_earlyaccess && salesChannelRegister.get('name') === "propertybooster" &&
                                                <img onClick={() => this.setState({ plugin_leadform_earlyaccess: false, plugin_leadform_moreinfo: false, plugin_leadform_viewing: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_earlyaccess && salesChannelRegister.get('name') === "boostabostad" &&
                                                <img onClick={() => this.setState({ plugin_leadform_earlyaccess: false, plugin_leadform_moreinfo: false, plugin_leadform_viewing: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_leadform_earlyaccess && salesChannelRegister.get('name') === "yieldlock" &&
                                                <img onClick={() => this.setState({ plugin_leadform_earlyaccess: false, plugin_leadform_moreinfo: false, plugin_leadform_viewing: false, plugin_leadform_callback: false })}
                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={Styles.checkMarksContainerItemText}>
                                                {this.parsers.text("item_94")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.plugin_listings &&
                                                <img onClick={() => this.setState({ plugin_listings: true, plugin_agency_listings: false })}
                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_listings && salesChannelRegister.get('name') === "propertybooster" &&
                                                <img onClick={() => this.setState({ plugin_listings: false, plugin_agency_listings: false })}
                                                    src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_listings && salesChannelRegister.get('name') === "boostabostad" &&
                                                <img onClick={() => this.setState({ plugin_listings: false, plugin_agency_listings: false })}
                                                    src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_listings && salesChannelRegister.get('name') === "yieldlock" &&
                                                <img onClick={() => this.setState({ plugin_listings: false, plugin_agency_listings: false })}
                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={Styles.checkMarksContainerItemText}>
                                                {this.parsers.text("item_75")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage && this.state.inhouse &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.plugin_agency_listings &&
                                                <img onClick={() => this.setState({ plugin_agency_listings: true, plugin_listings: false })}
                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_agency_listings && salesChannelRegister.get('name') === "propertybooster" &&
                                                <img onClick={() => this.setState({ plugin_agency_listings: false, plugin_listings: false })}
                                                    src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_agency_listings && salesChannelRegister.get('name') === "boostabostad" &&
                                                <img onClick={() => this.setState({ plugin_agency_listings: false, plugin_listings: false })}
                                                    src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_agency_listings && salesChannelRegister.get('name') === "yieldlock" &&
                                                <img onClick={() => this.setState({ plugin_agency_listings: false, plugin_listings: false })}
                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={Styles.checkMarksContainerItemText}>
                                                {this.parsers.text("item_99")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.plugin_image_blocker &&
                                                <img onClick={() => this.setState({ plugin_image_blocker: true })}
                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_image_blocker && salesChannelRegister.get('name') === "propertybooster" &&
                                                <img onClick={() => this.setState({ plugin_image_blocker: false, plugin_prequalify: false })}
                                                    src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_image_blocker && salesChannelRegister.get('name') === "boostabostad" &&
                                                <img onClick={() => this.setState({ plugin_image_blocker: false, plugin_prequalify: false })}
                                                    src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_image_blocker && salesChannelRegister.get('name') === "yieldlock" &&
                                                <img onClick={() => this.setState({ plugin_image_blocker: false, plugin_prequalify: false })}
                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={Styles.checkMarksContainerItemText}>
                                                {this.parsers.text("item_97")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage && this.state.plugin_image_blocker &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div style={{ marginLeft: 'calc(var(--size-factor) * 0px)' }} className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.plugin_prequalify &&
                                                <img onClick={() => this.setState({ plugin_prequalify: true })}
                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_prequalify && salesChannelRegister.get('name') === "propertybooster" &&
                                                <img onClick={() => this.setState({ plugin_prequalify: false })}
                                                    src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_prequalify && salesChannelRegister.get('name') === "boostabostad" &&
                                                <img onClick={() => this.setState({ plugin_prequalify: false })}
                                                    src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_prequalify && salesChannelRegister.get('name') === "yieldlock" &&
                                                <img onClick={() => this.setState({ plugin_prequalify: false })}
                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A', paddingRight: 'calc(var(--size-factor) * 20px)' } : { paddingRight: 'calc(var(--size-factor) * 20px)' }} className={Styles.checkMarksContainerItemText}>
                                                {this.parsers.text("item_103")}
                                            </div>
                                            {
                                                <div
                                                    style={salesChannelRegister.get('name') === 'yieldlock' ? { backgroundColor: '#E65032' } : {}}
                                                    className={Styles.optionsContainerItemInnerBadge}>
                                                    {this.parsers.text("item_104")}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.plugin_extraservices &&
                                                <img onClick={() => this.setState({ plugin_extraservices: true })}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_extraservices && salesChannelRegister.get('name') === "propertybooster" &&
                                                <img onClick={() => this.setState({ plugin_extraservices: false })}
                                                     src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                     className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_extraservices && salesChannelRegister.get('name') === "boostabostad" &&
                                                <img onClick={() => this.setState({ plugin_extraservices: false })}
                                                     src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                     className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_extraservices && salesChannelRegister.get('name') === "yieldlock" &&
                                                <img onClick={() => this.setState({ plugin_extraservices: false })}
                                                     src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                     className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={Styles.checkMarksContainerItemText}>
                                                {this.parsers.text("item_124")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                false && this.state.landingpage && salesChannelRegister.get('name') !== "boostabostad" &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.plugin_conveyancing &&
                                                <img onClick={() => this.setState({ plugin_conveyancing: true })}
                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_conveyancing && salesChannelRegister.get('name') !== "yieldlock" &&
                                                <img onClick={() => this.setState({ plugin_conveyancing: false })}
                                                    src={require("../../assets/images/square_checkmark_active.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                this.state.plugin_conveyancing && salesChannelRegister.get('name') === "yieldlock" &&
                                                <img onClick={() => this.setState({ plugin_conveyancing: false })}
                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={Styles.checkMarksContainerItemText}>
                                                {this.parsers.text("item_76")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage &&
                                this.renders.previewLandingPage()
                            }
                            {
                                this.state.landingpage &&
                                <div className={Styles.brokerInformationImage}>
                                    <div
                                        style={{ backgroundImage: "url(" + this.state.broker_image + ")" }}
                                        className={Styles.brokerInformationImageItem}>
                                        {
                                            this.state.broker_image && this.state.inhouse &&
                                            <div className={Styles.brokerInformationImageItemPlus}>
                                                <input
                                                    onChange={(e) => this.functions.changeProfileImage(e)}
                                                    type="file" accept="image/jpeg, image/png"
                                                    className={Styles.brokerInformationImageItemPlusUpload} />
                                                <img
                                                    className={Styles.brokerInformationImageItemPlusIcon}
                                                    src={require("../../assets/images/plus_sign_white_small.png")} />
                                            </div>
                                        }
                                        {
                                            !this.state.broker_image && this.state.inhouse &&
                                            <div
                                                className={Styles.brokerInformationImageItemLargePlus}>
                                                <input
                                                    onChange={(e) => this.functions.changeProfileImage(e)}
                                                    type="file" accept="image/jpeg, image/png"
                                                    className={Styles.brokerInformationImageItemPlusUpload} />
                                                +
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage && (salesChannelRegister.get('name') === "propertybooster" || salesChannelRegister.get('name') === "yieldlock") &&
                                <div className={Styles.brokerInformationQrCode}>
                                    <div
                                        style={{ backgroundImage: "url(" + this.state.broker_qrcode + ")" }}
                                        className={Styles.brokerInformationQrCodeItem}>
                                        {
                                            this.state.broker_qrcode &&
                                            <div className={Styles.brokerInformationQrCodeItemPlus}>
                                                <input
                                                    onChange={(e) => this.functions.changeQrCodeImage(e)}
                                                    type="file" accept="image/jpeg, image/png"
                                                    className={Styles.brokerInformationImageItemPlusUpload} />
                                                <img
                                                    className={Styles.brokerInformationImageItemPlusIcon}
                                                    src={require("../../assets/images/plus_sign_white_small.png")} />
                                            </div>
                                        }
                                        {
                                            !this.state.broker_qrcode &&
                                            <div
                                                className={Styles.brokerInformationQrCodeItemLargePlus}>
                                                <input
                                                    onChange={(e) => this.functions.changeQrCodeImage(e)}
                                                    type="file" accept="image/jpeg, image/png"
                                                    className={Styles.brokerInformationImageItemPlusUpload} />
                                                +
                                            </div>
                                        }
                                        {
                                            <div className={Styles.brokerInformationQrCodeItemText}>
                                                {this.parsers.text("item_125")}
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>

                        {/* Conversion Event */}
                        {
                            //this.state.inhouse &&
                            this.state.show_strategy &&
                            this.state.landingpage &&
                            <div className={Styles.itemHeader}>
                                <div onClick={() => this.setState({ show_four: !this.state.show_four })}
                                    className={Styles.itemHeaderInner}>
                                    <div className={Styles.itemHeaderInnerLeft}>
                                        {this.parsers.text("item_111")}
                                    </div>
                                    <img className={
                                        cx(Styles.itemHeaderArrow,
                                            {
                                                [Styles.itemHeaderArrowActive]: !this.state.show_four,
                                            })
                                    } src={require("../../assets/images/arrow-icon-grey.svg")} />
                                </div>
                            </div>
                        }
                        {
                            //this.state.inhouse &&
                            this.state.show_strategy &&
                            this.state.landingpage &&
                            <div className={cx(Styles.inputDividerFour,
                                {
                                    [Styles.inputDividerFourOpen]: !this.state.show_four
                                })}>
                                <div style={{ justifyContent: 'left' }} className={cx(Styles.inputDivider)}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemInner}>
                                            <div style={{ width: '100%' }}>
                                                <Dropdown
                                                    options={this.state.strategy.options}
                                                    disabled={this.state.strategy.disabled}
                                                    placeholder={this.state.strategy.placeholder}
                                                    value={this.state.strategy.value}
                                                    onChange={(item) => {
                                                        if (item !== '-1') {
                                                            this.state.strategy.value = item;
                                                            if (JSON.parse(this.state.strategy.value).type === 3) {
                                                                this.setState({ plugin_image_blocker: true, plugin_prequalify: true })
                                                            } else {
                                                                this.setState({ plugin_image_blocker: true, plugin_prequalify: false })
                                                            }
                                                            this.setState({
                                                                strategy: this.state.strategy
                                                            });
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        JSON.parse(this.state.strategy.value).type === 0 &&
                                        <div
                                            className={Styles.itemHeaderPaymentTitleInfo}> {this.calculate.estimatedConversions(JSON.parse(this.state.strategy.value).result_cost) + "* " + this.parsers.text("item_114")}</div>
                                    }
                                    {
                                        JSON.parse(this.state.strategy.value).type === 1 && false &&
                                        <div
                                            className={Styles.itemHeaderPaymentTitleInfo}> {this.calculate.estimatedConversions(JSON.parse(this.state.strategy.value).result_cost) + "* " + this.parsers.text("item_114")}</div>
                                    }
                                    {
                                        JSON.parse(this.state.strategy.value).type === 2 &&
                                        <div
                                            className={Styles.itemHeaderPaymentTitleInfo}> {this.calculate.estimatedConversions(JSON.parse(this.state.strategy.value).result_cost) + "* " + this.parsers.text("item_114")}</div>
                                    }
                                    {
                                        JSON.parse(this.state.strategy.value).type === 3 &&
                                        <div
                                            className={Styles.itemHeaderPaymentTitleInfo}>{this.calculate.estimatedConversions(JSON.parse(this.state.strategy.value).result_cost) + "* " + this.parsers.text("item_114")}</div>
                                    }
                                    {
                                        JSON.parse(this.state.strategy.value).type === 4 &&
                                        <div
                                            className={Styles.itemHeaderPaymentTitleInfo}> {this.calculate.estimatedConversions(JSON.parse(this.state.strategy.value).result_cost) + "* " + this.parsers.text("item_114")}</div>
                                    }
                                    {
                                        JSON.parse(this.state.strategy.value).type === 5 && false &&
                                        <div
                                            className={Styles.itemHeaderPaymentTitleInfo}> {this.calculate.estimatedConversions(JSON.parse(this.state.strategy.value).result_cost) + "* " + this.parsers.text("item_114")}</div>
                                    }
                                    {
                                        JSON.parse(this.state.strategy.value).type === 6 && false &&
                                        <div
                                            className={Styles.itemHeaderPaymentTitleInfo}> {this.calculate.estimatedConversions(JSON.parse(this.state.strategy.value).result_cost) + "* " + this.parsers.text("item_114")}</div>
                                    }
                                    {
                                        JSON.parse(this.state.strategy.value).type === 7 && false &&
                                        <div
                                            className={Styles.itemHeaderPaymentTitleInfo}> {this.calculate.estimatedConversions(JSON.parse(this.state.strategy.value).result_cost) + "* " + this.parsers.text("item_114")}</div>
                                    }
                                </div>
                                {
                                    /*
                                    false &&
                                    <div className={cx(Styles.inputDivider)}>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDividerItemInner}>
                                                <div style={{ width: '100%' }}>
                                                    <Dropdown
                                                        options={this.state.strategy_pixels.options}
                                                        disabled={this.state.strategy_pixels.disabled}
                                                        placeholder={this.state.strategy_pixels.placeholder}
                                                        value={this.state.strategy_pixels.value}
                                                        onChange={(item) => {
                                                            if (item !== '-1') {
                                                                this.state.strategy_pixels.value = item;
                                                                this.setState({
                                                                    strategy_pixels: this.state.strategy_pixels
                                                                });
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    */
                                }
                            </div>
                        }
                        {
                            this.state.landingpage && false &&
                            <div className={cx(Styles.inputDividerFour,
                                {
                                    [Styles.inputDividerFourOpen]: this.state.show_four
                                })}>
                                <div className={cx(Styles.inputDivider)}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemInner}>
                                            <input
                                                value={this.state.feed_country}
                                                onChange={(event) => this.setState({ feed_country: event.target.value })}
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: false
                                                    })}
                                                disabled={false}
                                                placeholder={"Country*"}
                                            />
                                            {
                                                false &&
                                                this.state.form_validation.redirect_email && this.state.redirect && !this.validators.email(this.state.redirect_email) &&
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                    className={Styles.inputError}></div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={cx(Styles.inputDivider)}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemInner}>
                                            <input
                                                value={this.state.feed_region}
                                                onChange={(event) => this.setState({ feed_region: event.target.value })}
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: false
                                                    })}
                                                disabled={false}
                                                placeholder={"Region*"}
                                            />
                                            {
                                                false &&
                                                this.state.form_validation.redirect_email && this.state.redirect && !this.validators.email(this.state.redirect_email) &&
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                    className={Styles.inputError}></div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={cx(Styles.inputDivider)}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemInner}>
                                            <div className={Styles.inputDividerItemInnerInput}>
                                                <input
                                                    value={this.state.feed_city}
                                                    onChange={(event) => this.setState({ feed_city: event.target.value })}
                                                    style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                    className={cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: false
                                                        })}
                                                    disabled={false}
                                                    placeholder={"City*"}
                                                />
                                                {
                                                    false &&
                                                    this.state.form_validation.redirect_email && this.state.redirect && !this.validators.email(this.state.redirect_email) &&
                                                    <div
                                                        style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                        className={Styles.inputError}></div>
                                                }
                                            </div>
                                            <div className={Styles.inputDividerItemInnerDropdown}>
                                                <input
                                                    value={this.state.feed_zipcode}
                                                    onChange={(event) => this.setState({ feed_zipcode: event.target.value })}
                                                    style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                    className={cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: false
                                                        })}
                                                    disabled={false}
                                                    placeholder={"Zipcode"}
                                                />
                                                {
                                                    false &&
                                                    this.state.form_validation.redirect_email && this.state.redirect && !this.validators.email(this.state.redirect_email) &&
                                                    <div
                                                        style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                        className={Styles.inputError}></div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={cx(Styles.inputDivider)}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemInner}>
                                            <input
                                                value={this.state.feed_neighborhood}
                                                onChange={(event) => this.setState({ feed_neighborhood: event.target.value })}
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: false
                                                    })}
                                                disabled={false}
                                                placeholder={"Neighborhood*"}
                                            />
                                            {
                                                false &&
                                                this.state.form_validation.redirect_email && this.state.redirect && !this.validators.email(this.state.redirect_email) &&
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                    className={Styles.inputError}></div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={cx(Styles.inputDivider)}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemInner}>
                                            <input
                                                value={this.state.feed_address}
                                                onChange={(event) => this.setState({ feed_address: event.target.value })}
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: false
                                                    })}
                                                disabled={false}
                                                placeholder={"Address*"}
                                            />
                                            {
                                                false &&
                                                this.state.form_validation.redirect_email && this.state.redirect && !this.validators.email(this.state.redirect_email) &&
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                    className={Styles.inputError}></div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }


                        <div className={Styles.itemHeader}>
                            <div onClick={() => this.setState({ show_two: !this.state.show_two })}
                                className={Styles.itemHeaderInner}>
                                <div className={Styles.itemHeaderInnerLeft}>
                                    {this.parsers.text("item_93")}
                                </div>
                                <img className={
                                    cx(Styles.itemHeaderArrow,
                                        {
                                            [Styles.itemHeaderArrowActive]: this.state.show_two,
                                        })
                                } src={require("../../assets/images/arrow-icon-grey.svg")} />
                            </div>
                        </div>
                        <div className={cx(Styles.inputDivider, Styles.inputDividerOne,
                            {
                                [Styles.inputDividerOneOpen]: this.state.show_two,
                                [Styles.inputDividerSecondOpen]: this.state.show_two
                            })}>
                            <div className={Styles.iconsContainer}>
                                {
                                    this.renders.previewAds('google') &&
                                    <div onClick={() => this._placement('google')}
                                        className={Styles.iconsContainerItem}>
                                        <img className={Styles.iconsContainerItemGoogle}
                                            src={require('../../assets/images/google_logo_icon.svg')} />
                                    </div>
                                }
                                {
                                    this.renders.previewAds('facebook') &&
                                    <div onClick={() => this._placement('facebook')}
                                        className={Styles.iconsContainerItem}>
                                        <img className={Styles.iconsContainerItemFacebook}
                                            src={require('../../assets/images/facebook_logo_icon.svg')} />
                                    </div>
                                }
                                {
                                    this.renders.previewAds('bing') &&
                                    <div onClick={() => this._placement('bing')}
                                        className={Styles.iconsContainerItem}>
                                        <img className={Styles.iconsContainerItemBing}
                                            src={require('../../assets/images/bing_logo_icon.svg')} />
                                    </div>
                                }
                                {
                                    this.renders.previewAds('instagram') &&
                                    <div onClick={() => this._placement('instagram')}
                                        className={Styles.iconsContainerItem}>
                                        <img className={Styles.iconsContainerItemInstagram}
                                            src={require('../../assets/images/instagram_logo_icon.svg')} />
                                    </div>
                                }
                            </div>
                        </div>
                        {
                            (this.state.reseller || this.state.inhouse) &&
                            <div>
                                <div className={Styles.itemHeader}>
                                    <div onClick={() => this.setState({ show_one: !this.state.show_one })}
                                        className={Styles.itemHeaderInner}>
                                        <div className={Styles.itemHeaderInnerLeft}>
                                            {this.parsers.text("item_38")}
                                        </div>
                                        <img className={
                                            cx(Styles.itemHeaderArrow,
                                                {
                                                    [Styles.itemHeaderArrowActive]: this.state.show_one,
                                                })
                                        } src={require("../../assets/images/arrow-icon-grey.svg")} />
                                    </div>
                                </div>

                                <div className={cx(Styles.inputDividerTwo,
                                    {
                                        [Styles.inputDividerTwoOpen]: this.state.show_one,
                                        [Styles.inputDividerTwoOpenRadio]: this.state.show_one && this.state.redirect,
                                        [Styles.inputDividerTwoOpenRadioInputs]: this.state.show_one && this.state.redirect && this.state.greetings_invoice && this.state.user_name && this.state.user_image,
                                        [Styles.inputDividerTwoOpenRadioInputsNoImage]: this.state.show_one && this.state.redirect && this.state.greetings_invoice && this.state.user_name && !this.state.user_image
                                    })}>
                                    <div className={cx(Styles.inputDivider)}>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                value={this.state.redirect ? this.state.redirect_email : this.state.user_email}
                                                onChange={(event) => this.setState({ redirect_email: event.target.value.toLowerCase() })}
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                className={cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.redirect
                                                    })}
                                                disabled={!this.state.redirect}
                                                placeholder={this.parsers.text("item_40")}
                                            />
                                            {
                                                this.state.form_validation.redirect_email && this.state.redirect && !this.validators.email(this.state.redirect_email) &&
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                    className={Styles.inputError}></div>
                                            }
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.checkMarksContainerItem}>
                                                {
                                                    !this.state.redirect &&
                                                    <img onClick={() => this.setState({ redirect: true })}
                                                        src={require("../../assets/images/square_checkmark_two.svg")}
                                                        className={Styles.checkMarksContainerItemIcon} />
                                                }
                                                {
                                                    salesChannelRegister.get("name") === "propertybooster" &&
                                                    this.state.redirect &&
                                                    <img onClick={() => this.setState({
                                                        redirect: false,
                                                        greetings_invoice: false
                                                    })}
                                                        src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                        className={Styles.checkMarksContainerItemIcon} />
                                                }
                                                {
                                                    salesChannelRegister.get("name") === "boostabostad" &&
                                                    this.state.redirect &&
                                                    <img onClick={() => this.setState({
                                                        redirect: false,
                                                        greetings_invoice: false
                                                    })}
                                                        src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                        className={Styles.checkMarksContainerItemIcon} />
                                                }
                                                {
                                                    salesChannelRegister.get("name") === "yieldlock" &&
                                                    this.state.redirect &&
                                                    <img onClick={() => this.setState({
                                                        redirect: false,
                                                        greetings_invoice: false
                                                    })}
                                                        src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                        className={Styles.checkMarksContainerItemIcon} />
                                                }
                                                <div className={Styles.checkMarksContainerItemText}>
                                                    {this.parsers.text("item_39")}
                                                </div>
                                                {
                                                    langRegister.lang() === "en" && salesChannelRegister.get('name') !== "yieldlock" && !this.state.inhouse &&
                                                    <img className={Styles.notificationBadge} src={require("../../assets/images/ab_notify_client_en.svg")} />
                                                }
                                                {
                                                    langRegister.lang() === "en" && salesChannelRegister.get('name') === "yieldlock" && !this.state.inhouse &&
                                                    <img className={Styles.notificationBadge} src={require("../../assets/images/ab_notify_client_en_yl.svg")} />
                                                }
                                                {
                                                    langRegister.lang() === "sv" && salesChannelRegister.get('name') !== "yieldlock" && !this.state.inhouse &&
                                                    <img className={Styles.notificationBadge} src={require("../../assets/images/ab_notify_client_sv.svg")} />
                                                }
                                                {
                                                    langRegister.lang() === "sv" && salesChannelRegister.get('name') === "yieldlock" && !this.state.inhouse &&
                                                    <img className={Styles.notificationBadge} src={require("../../assets/images/ab_notify_client_sv_yl.svg")} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        this.state.redirect &&
                                        <div className={cx(Styles.greetingsContainer,
                                            {
                                                [Styles.greetingsContainerDisabled]: this.state.pay_now
                                            })}>
                                            {
                                                this.state.pay_now &&
                                                <div className={Styles.paymentStepBlock}></div>
                                            }
                                            {
                                                <div className={Styles.radioButtonContainer}>
                                                    <div onClick={() => {
                                                        this.setState({ greetings_invoice: true });
                                                    }} className={Styles.radioButton}>
                                                        <div className={
                                                            cx(Styles.radioButtonCircle,
                                                                {
                                                                    [Styles.radioButtonCircleActive]: this.state.greetings_invoice,
                                                                })
                                                        }>
                                                            {
                                                                this.state.greetings_invoice &&
                                                                <div className={Styles.radioButtonCircleActiveCirlce} />
                                                            }
                                                        </div>
                                                        <div
                                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                            className={Styles.radioButtonTitle}>
                                                            {this.parsers.text("item_65")}
                                                        </div>
                                                    </div>
                                                    <div onClick={() => {
                                                        this.setState({ greetings_invoice: false });
                                                    }} className={Styles.radioButton}>
                                                        <div className={
                                                            cx(Styles.radioButtonCircle,
                                                                {
                                                                    [Styles.radioButtonCircleActive]: !this.state.greetings_invoice,
                                                                })
                                                        }>
                                                            {
                                                                !this.state.greetings_invoice &&
                                                                <div className={Styles.radioButtonCircleActiveCirlce} />
                                                            }
                                                        </div>
                                                        <div
                                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                            className={Styles.radioButtonTitle}>
                                                            {this.parsers.text("item_66")}
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                this.state.show_one && this.state.redirect && this.state.greetings_invoice && this.state.user_name && !this.state.pay_now &&
                                                <div className={cx(Styles.inputDivider)}>
                                                    <div className={Styles.inputDividerItem}>
                                                        <input
                                                            value={this.state.user_name}
                                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                            className={cx(Styles.input,
                                                                {
                                                                    [Styles.inputDisabled]: true
                                                                })}
                                                            disabled={true}
                                                            placeholder={this.parsers.text("item_68")}
                                                        />
                                                    </div>
                                                    {
                                                        this.state.user_image &&
                                                        <div className={Styles.inputDividerItem}>
                                                            <div className={Styles.checkMarksContainerItem}>
                                                                {
                                                                    !this.state.greetings_invoice_profileimage &&
                                                                    <img
                                                                        onClick={() => this.setState({ greetings_invoice_profileimage: true })}
                                                                        src={require("../../assets/images/square_checkmark_two.svg")}
                                                                        className={Styles.checkMarksContainerItemIcon} />
                                                                }
                                                                {
                                                                    salesChannelRegister.get("name") === "propertybooster" &&
                                                                    this.state.greetings_invoice_profileimage &&
                                                                    <img
                                                                        onClick={() => this.setState({ greetings_invoice_profileimage: false })}
                                                                        src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                                        className={Styles.checkMarksContainerItemIcon} />
                                                                }
                                                                {
                                                                    salesChannelRegister.get("name") === "boostabostad" &&
                                                                    this.state.greetings_invoice_profileimage &&
                                                                    <img
                                                                        onClick={() => this.setState({ greetings_invoice_profileimage: false })}
                                                                        src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                                        className={Styles.checkMarksContainerItemIcon} />
                                                                }
                                                                {
                                                                    salesChannelRegister.get("name") === "yieldlock" &&
                                                                    this.state.greetings_invoice_profileimage &&
                                                                    <img
                                                                        onClick={() => this.setState({ greetings_invoice_profileimage: false })}
                                                                        src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                                        className={Styles.checkMarksContainerItemIcon} />
                                                                }
                                                                <div className={Styles.checkMarksContainerItemText}>
                                                                    {this.parsers.text("item_67")}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {
                                                this.state.greetings_invoice && !this.state.pay_now && false &&
                                                <div className={cx(Styles.inputDivider)}>
                                                    <div className={Styles.inputDividerItem}>
                                                        <input
                                                            value={this.state.user_email}
                                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                            className={cx(Styles.input,
                                                                {
                                                                    [Styles.inputDisabled]: true
                                                                })}
                                                            disabled={true}
                                                            placeholder={this.parsers.text("item_71")}
                                                        />
                                                    </div>
                                                    <div className={Styles.inputDividerItem}>
                                                        <div className={Styles.checkMarksContainerItem}>
                                                            {
                                                                salesChannelRegister.get("name") !== "yieldlock" &&
                                                                !this.state.greetings_invoice_email &&
                                                                <img
                                                                    onClick={() => this.setState({ greetings_invoice_email: true })}
                                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                                    className={Styles.checkMarksContainerItemIcon} />
                                                            }
                                                            {
                                                                salesChannelRegister.get("name") !== "yieldlock" &&
                                                                this.state.greetings_invoice_email &&
                                                                <img
                                                                    onClick={() => this.setState({ greetings_invoice_email: false })}
                                                                    src={require("../../assets/images/square_checkmark_active.svg")}
                                                                    className={Styles.checkMarksContainerItemIcon} />
                                                            }
                                                            {
                                                                salesChannelRegister.get("name") === "yieldlock" &&
                                                                !this.state.greetings_invoice_email &&
                                                                <img
                                                                    onClick={() => this.setState({ greetings_invoice_email: true })}
                                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                                    className={Styles.checkMarksContainerItemIcon} />
                                                            }
                                                            {
                                                                salesChannelRegister.get("name") === "yieldlock" &&
                                                                this.state.greetings_invoice_email &&
                                                                <img
                                                                    onClick={() => this.setState({ greetings_invoice_email: false })}
                                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                                    className={Styles.checkMarksContainerItemIcon} />
                                                            }
                                                            <div className={Styles.checkMarksContainerItemText}>
                                                                {this.parsers.text("item_69")}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                this.state.greetings_invoice && !this.state.pay_now && false &&
                                                <div className={cx(Styles.inputDivider)}>
                                                    <div className={Styles.inputDividerItem}>
                                                        <input
                                                            value={this.state.user_phone}
                                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                                            className={cx(Styles.input,
                                                                {
                                                                    [Styles.inputDisabled]: true
                                                                })}
                                                            disabled={true}
                                                            placeholder={this.parsers.text("item_72")}
                                                        />
                                                    </div>
                                                    <div className={Styles.inputDividerItem}>
                                                        <div className={Styles.checkMarksContainerItem}>
                                                            {
                                                                salesChannelRegister.get("name") !== "yieldlock" &&
                                                                !this.state.greetings_invoice_phone &&
                                                                <img
                                                                    onClick={() => this.setState({ greetings_invoice_phone: true })}
                                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                                    className={Styles.checkMarksContainerItemIcon} />
                                                            }
                                                            {
                                                                salesChannelRegister.get("name") !== "yieldlock" &&
                                                                this.state.greetings_invoice_phone &&
                                                                <img
                                                                    onClick={() => this.setState({ greetings_invoice_phone: false })}
                                                                    src={require("../../assets/images/square_checkmark_active.svg")}
                                                                    className={Styles.checkMarksContainerItemIcon} />
                                                            }
                                                            {
                                                                salesChannelRegister.get("name") === "yieldlock" &&
                                                                !this.state.greetings_invoice_phone &&
                                                                <img
                                                                    onClick={() => this.setState({ greetings_invoice_phone: true })}
                                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                                    className={Styles.checkMarksContainerItemIcon} />
                                                            }
                                                            {
                                                                salesChannelRegister.get("name") === "yieldlock" &&
                                                                this.state.greetings_invoice_phone &&
                                                                <img
                                                                    onClick={() => this.setState({ greetings_invoice_phone: false })}
                                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                                    className={Styles.checkMarksContainerItemIcon} />
                                                            }
                                                            <div className={Styles.checkMarksContainerItemText}>
                                                                {this.parsers.text("item_70")}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        {
                            (this.state.reseller || this.state.inhouse) && false &&
                            <div>

                                <div className={Styles.itemHeader}>
                                    <div onClick={() => this.setState({ show_one: !this.state.show_one })}
                                        className={Styles.itemHeaderInner}>
                                        <div className={Styles.itemHeaderInnerLeft}>
                                            {this.parsers.text("item_38")}
                                        </div>
                                        <img className={
                                            cx(Styles.itemHeaderArrow,
                                                {
                                                    [Styles.itemHeaderArrowActive]: this.state.show_one,
                                                })
                                        } src={require("../../assets/images/arrow-icon-grey.svg")} />
                                    </div>
                                </div>

                                <div className={cx(Styles.inputDivider, Styles.inputDividerOne,
                                    {
                                        [Styles.inputDividerOneOpen]: this.state.show_one
                                    })}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            value={this.state.redirect ? this.state.redirect_email : this.state.user_email}
                                            onChange={(event) => this.setState({ redirect_email: event.target.value.toLowerCase() })}
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                            className={cx(Styles.input,
                                                {
                                                    [Styles.inputDisabled]: !this.state.redirect
                                                })}
                                            disabled={!this.state.redirect}
                                            placeholder={this.parsers.text("item_40")}
                                        />
                                        {
                                            this.state.form_validation.redirect_email && this.state.redirect && !this.validators.email(this.state.redirect_email) &&
                                            <div
                                                style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                className={Styles.inputError}></div>
                                        }
                                    </div>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                salesChannelRegister.get("name") !== "yieldlock" &&
                                                !this.state.redirect &&
                                                <img onClick={() => this.setState({ redirect: true })}
                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                salesChannelRegister.get("name") !== "yieldlock" &&
                                                this.state.redirect &&
                                                <img
                                                    onClick={() => this.setState({ redirect: false })}
                                                    src={require("../../assets/images/square_checkmark_active.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                salesChannelRegister.get("name") === "yieldlock" &&
                                                !this.state.redirect &&
                                                <img onClick={() => this.setState({ redirect: true })}
                                                    src={require("../../assets/images/square_checkmark_two.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }
                                            {
                                                salesChannelRegister.get("name") === "yieldlock" &&
                                                this.state.redirect &&
                                                <img
                                                    onClick={() => this.setState({ redirect: false })}
                                                    src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                    className={Styles.checkMarksContainerItemIcon} />
                                            }

                                            <div className={Styles.checkMarksContainerItemText}>
                                                {this.parsers.text("item_39")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        <div className={Styles.itemHeader}>
                            <div onClick={() => this.setState({ show_three: !this.state.show_three })}
                                className={Styles.itemHeaderInner}>
                                <div className={Styles.itemHeaderInnerLeft}>
                                    {this.parsers.text("item_27")}
                                </div>
                                <img className={
                                    cx(Styles.itemHeaderArrow,
                                        {
                                            [Styles.itemHeaderArrowActive]: this.state.show_three,
                                        })
                                } src={require("../../assets/images/arrow-icon-grey.svg")} />
                            </div>
                        </div>
                        <div className={cx(Styles.inputDividerCoupon, Styles.inputDividerOne,
                            {
                                [Styles.inputDividerOneOpen]: this.state.show_three
                            })}>
                            <div className={Styles.inputDividerItem}>
                                <input
                                    value={this.state.coupon}
                                    onChange={(event) => this.setState({ coupon: event.target.value })}
                                    style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                    className={Styles.input}
                                    disabled={this.state.isCouponLoading || this.state.coupon_success}
                                    placeholder={this.parsers.text("item_42")}
                                />
                            </div>
                            <div className={Styles.inputDividerItemCoupon}>
                                <div onClick={() => {
                                    if (this.state.coupon_success) {
                                        this.setState({ discount: null, coupon_success: false, coupon: "" })
                                    } else {
                                        this.functions.checkCoupon()
                                    }
                                }} className={
                                    cx(Styles.couponButton,
                                        {
                                            [Styles.couponButtonSuccess]: this.state.coupon_success,
                                            [Styles.couponButtonSuccessYieldlock]: this.state.coupon_success && salesChannelRegister.get("name") === "yieldlock",
                                        })
                                }>
                                    {
                                        !this.state.isCouponLoading && !this.state.coupon_success &&
                                        <span>{this.parsers.text("item_28")}</span>
                                    }
                                    {
                                        !this.state.isCouponLoading && this.state.coupon_success &&
                                        <span>{this.parsers.text("item_58")}{" "}{this.state.discount}{" "}{this.state.currency}</span>
                                    }
                                    {
                                        this.state.isCouponLoading &&
                                        <BeatLoader size={10} color={'#ffffff'} loading={true} />
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={Styles.itemHeaderPayment}>
                            <div className={Styles.itemHeaderPaymentTitle}>
                                {this.parsers.text("item_15")}
                                {
                                    dataRegister.api.primehit === "https://api.devprimehit.com/v1" &&
                                    <span
                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#E65032' } : {}}
                                        className={Styles.itemHeaderPaymentTitleWarning}>{" "}(demo)</span>
                                }
                            </div>
                            <img src={require("../../assets/images/AB_payment_verified.png")}
                                className={Styles.itemHeaderPaymentVerified} />
                            <img src={require("../../assets/images/stripe_logo.svg")}
                                className={Styles.itemHeaderPaymentIcon} />
                        </div>
                        {
                            <div className={Styles.radioButtonContainer}>
                                <div onClick={() => {
                                    window.cardNumber.update({ disabled: false });
                                    window.cardExpiry.update({ disabled: false });
                                    window.cardCvc.update({ disabled: false });
                                    this.setState({ pay_now: true, greetings_invoice: false });
                                }} className={Styles.radioButton}>
                                    <div className={
                                        cx(Styles.radioButtonCircle,
                                            {
                                                [Styles.radioButtonCircleActive]: this.state.pay_now,
                                            })
                                    }>
                                        {
                                            this.state.pay_now &&
                                            <div className={Styles.radioButtonCircleActiveCirlce} />
                                        }
                                    </div>
                                    <div
                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                        className={Styles.radioButtonTitle}>
                                        {this.parsers.text("item_35")}
                                    </div>
                                </div>
                                <div onClick={() => {
                                    window.cardNumber.update({ disabled: true });
                                    window.cardExpiry.update({ disabled: true });
                                    window.cardCvc.update({ disabled: true });
                                    window.cardNumber.clear();
                                    window.cardExpiry.clear();
                                    window.cardCvc.clear();
                                    this.state.card_error.number = false;
                                    this.state.card_error.expiry = false;
                                    this.state.card_error.cvc = false;
                                    this.state.card_error.message = "";
                                    this.state.card_error.show = false;
                                    this.setState({
                                        pay_now: false,
                                        card_error: this.state.card_error
                                    });
                                }} className={Styles.radioButton}>
                                    <div className={
                                        cx(Styles.radioButtonCircle,
                                            {
                                                [Styles.radioButtonCircleActive]: !this.state.pay_now,
                                            })
                                    }>
                                        {
                                            !this.state.pay_now &&
                                            <div className={Styles.radioButtonCircleActiveCirlce} />
                                        }
                                    </div>
                                    <div
                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                        className={Styles.radioButtonTitle}>
                                        {this.parsers.text("item_36")}
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            <div className={
                                cx(
                                    {
                                        [Styles.paymentOverlayPayNow]: !this.state.pay_now,
                                    })
                            }>
                                <div className={
                                    cx(Styles.inputDivider, Styles.inputDividerIconsTop,
                                        {
                                            [Styles.inputDividerExtraSpace]: (!this.state.reseller && !this.state.inhouse) || !this.state.landingpage,
                                        })
                                }>
                                    <div
                                        className={cx(Styles.inputDividerItem, Styles.inputDividerItemCardsFirst)}>
                                        <div className={Styles.paymentCards}>
                                            <img className={Styles.paymentCardsItem}
                                                src={require("../../assets/images/AB_payment_cards.png")} />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={cx(Styles.inputDivider, Styles.inputDividerIconsTop)}>
                                    <div
                                        className={cx(Styles.inputDividerItem, Styles.inputDividerItemCards)}>
                                        <div className={cx(Styles.input)} id={"card-number"} />
                                        {
                                            this.state.card_error.number &&
                                            <div
                                                style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                className={Styles.inputError} />
                                        }
                                    </div>
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={cx(Styles.inputDividerItemPaymentContainer)}>
                                        <div className={cx(Styles.inputDividerItemPaymentExpiry)}>
                                            <div className={cx(Styles.input)}
                                                id={"card-expiry"}></div>
                                            {
                                                this.state.card_error.expiry &&
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                    className={Styles.inputError} />
                                            }
                                        </div>
                                        <div className={Styles.inputDividerItemPayment}>
                                            <div className={cx(Styles.input)} id={"card-cvc"}></div>
                                            {
                                                this.state.card_error.cvc &&
                                                <div
                                                    style={salesChannelRegister.get('name') === "yieldlock" ? { borderColor: '#E65032' } : {}}
                                                    className={Styles.inputError} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className={Styles.divider} />
                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { color: '#E65032' } : {}}
                            className={
                                cx(Styles.errorMessage,
                                    {
                                        [Styles.errorMessageActive]: this.state.error || this.state.card_error.cvc || this.state.card_error.number || this.state.card_error.month || this.state.card_error.year || this.state.website_error || this.state.card_error.show || this.state.user_error
                                    })
                            }>
                            {
                                this.state.website_error &&
                                this.parsers.text("item_56")
                            }
                            {
                                this.state.card_error.show &&
                                this.parsers.text("item_34")
                            }
                            {
                                this.state.error === 401 &&
                                this.parsers.text("item_33")
                            }
                            {
                                this.state.error === 404 &&
                                this.parsers.text("item_34")
                            }
                            {
                                this.state.error && this.state.error !== 404 && this.state.error !== 401 &&
                                this.parsers.text("item_34")
                            }
                            {
                                this.state.user_error &&
                                this.parsers.text("item_54")
                            }
                        </div>
                        {
                            !this.state.isLoading &&
                            <div>
                                <div onClick={() => this._payment()} className={Styles.button}>
                                    {
                                        this.state.pay_now &&
                                        <span>{this.parsers.text("item_20")}{" "}{this.parsers.number(this.calculate.partialBudget())}{" "}{this.state.currency.toLowerCase()}</span>
                                    }
                                    {
                                        !this.state.pay_now &&
                                        <span>{this.parsers.text("item_37")}</span>
                                    }
                                </div>
                            </div>
                        }
                        <div
                            onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/checkout")}
                            className={Styles.backButton}
                            style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}>
                            {this.parsers.text("item_26")}
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true} />
                    </div>
                }
                {
                    !this.state.isLoading && this.state.system_error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props} />
                    </div>
                }
            </div>
        );
    }
}

export default BoosterPayment;


// WEBPACK FOOTER //
// ./src/pages/booster-payment/component.js